/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptAIFieldRequest } from '../models/AcceptAIFieldRequest';
import type { AcceptAIFieldResponse } from '../models/AcceptAIFieldResponse';
import type { AcceptAllAIFieldsResponse } from '../models/AcceptAllAIFieldsResponse';
import type { AddBulkDashboardUser } from '../models/AddBulkDashboardUser';
import type { AddDocumentReferencesToFolderRequest } from '../models/AddDocumentReferencesToFolderRequest';
import type { AddNewDashboardUser } from '../models/AddNewDashboardUser';
import type { AddOrRemoveRequestItems } from '../models/AddOrRemoveRequestItems';
import type { AdminDelegateDocumentRequest } from '../models/AdminDelegateDocumentRequest';
import type { AIAssistRequest } from '../models/AIAssistRequest';
import type { AIAssistResponse } from '../models/AIAssistResponse';
import type { AIClassification } from '../models/AIClassification';
import type { AIReviewBatchRequest } from '../models/AIReviewBatchRequest';
import type { AIReviewBatchResponse } from '../models/AIReviewBatchResponse';
import type { AllocationCompanyModel } from '../models/AllocationCompanyModel';
import type { AllocationConclusionModel } from '../models/AllocationConclusionModel';
import type { AllocationModel } from '../models/AllocationModel';
import type { AllocationName } from '../models/AllocationName';
import type { ApiCreateDocumentGenerationJob } from '../models/ApiCreateDocumentGenerationJob';
import type { ApplyCapTableGenerationJob } from '../models/ApplyCapTableGenerationJob';
import type { AuditLogsAccessResponse } from '../models/AuditLogsAccessResponse';
import type { AutoUpdatedFirmReportZipModel } from '../models/AutoUpdatedFirmReportZipModel';
import type { AvailableAllocation } from '../models/AvailableAllocation';
import type { AvailableFund } from '../models/AvailableFund';
import type { BackupCodes } from '../models/BackupCodes';
import type { BackupCodeVerify } from '../models/BackupCodeVerify';
import type { BulkValuationUpdate } from '../models/BulkValuationUpdate';
import type { BulkValuationUpdateResponse } from '../models/BulkValuationUpdateResponse';
import type { CapTableDetailsModel } from '../models/CapTableDetailsModel';
import type { CapTableFundOwnership } from '../models/CapTableFundOwnership';
import type { CapTableGrossIRRResponse } from '../models/CapTableGrossIRRResponse';
import type { CapTableGrossIRRsResponse } from '../models/CapTableGrossIRRsResponse';
import type { CapTableModel } from '../models/CapTableModel';
import type { CapTableName } from '../models/CapTableName';
import type { CapTableSecurities } from '../models/CapTableSecurities';
import type { CashDistributionExclusion } from '../models/CashDistributionExclusion';
import type { CashFlowLedgerBulkSave } from '../models/CashFlowLedgerBulkSave';
import type { CashFlowLedgerItem } from '../models/CashFlowLedgerItem';
import type { ChartDataResponse } from '../models/ChartDataResponse';
import type { ChoiceAnswerModel } from '../models/ChoiceAnswerModel';
import type { CitationReviewRequest } from '../models/CitationReviewRequest';
import type { CitationReviewResponse } from '../models/CitationReviewResponse';
import type { ClassificationApproval } from '../models/ClassificationApproval';
import type { ClassifyDocument } from '../models/ClassifyDocument';
import type { CommonCompanyProfile } from '../models/CommonCompanyProfile';
import type { CommonCompanyProfileNews } from '../models/CommonCompanyProfileNews';
import type { CommonCompanyProfileSuggest } from '../models/CommonCompanyProfileSuggest';
import type { CommonCompanyProfileSuggestResponse } from '../models/CommonCompanyProfileSuggestResponse';
import type { CommonCompanyProfileWrite } from '../models/CommonCompanyProfileWrite';
import type { CommonProfileCompany } from '../models/CommonProfileCompany';
import type { CompaniesByFirm } from '../models/CompaniesByFirm';
import type { Company } from '../models/Company';
import type { CompanyCapIQFundingRounds } from '../models/CompanyCapIQFundingRounds';
import type { CompanyCapIQOverview } from '../models/CompanyCapIQOverview';
import type { CompanyDailyNavConfigCurrent } from '../models/CompanyDailyNavConfigCurrent';
import type { CompanyDailyNavConfigUpdate } from '../models/CompanyDailyNavConfigUpdate';
import type { CompanyDailyNavConfigVersion } from '../models/CompanyDailyNavConfigVersion';
import type { CompanyDocuments } from '../models/CompanyDocuments';
import type { CompanyFileStorageReferenceUpdate } from '../models/CompanyFileStorageReferenceUpdate';
import type { CompanyFinancialHistory } from '../models/CompanyFinancialHistory';
import type { CompanyFundingRounds } from '../models/CompanyFundingRounds';
import type { CompanyLinkProfile } from '../models/CompanyLinkProfile';
import type { CompanyMeasurementDateFileStorageReferenceUpdate } from '../models/CompanyMeasurementDateFileStorageReferenceUpdate';
import type { CompanyMeasurementDateModel } from '../models/CompanyMeasurementDateModel';
import type { CompanyMeasurementDateName } from '../models/CompanyMeasurementDateName';
import type { CompanyMeasurementDateNameNullable } from '../models/CompanyMeasurementDateNameNullable';
import type { CompanyPrimaryContact } from '../models/CompanyPrimaryContact';
import type { CompanyQuestionSync } from '../models/CompanyQuestionSync';
import type { CompanyRequestedDocumentModel } from '../models/CompanyRequestedDocumentModel';
import type { CompanyRequestedInformation } from '../models/CompanyRequestedInformation';
import type { CompanySummaryResponse } from '../models/CompanySummaryResponse';
import type { CompGroupListCreate } from '../models/CompGroupListCreate';
import type { ConfirmPdfExportUpload } from '../models/ConfirmPdfExportUpload';
import type { ConfirmProfileBody } from '../models/ConfirmProfileBody';
import type { Create409Report } from '../models/Create409Report';
import type { CreateCompanyInformationRequest } from '../models/CreateCompanyInformationRequest';
import type { CreateDocumentAndQuestionnaireTasks } from '../models/CreateDocumentAndQuestionnaireTasks';
import type { CreateFirmRequests } from '../models/CreateFirmRequests';
import type { CreateOnboardingTasks } from '../models/CreateOnboardingTasks';
import type { CreateOrDeleteDocumentReferenceObject } from '../models/CreateOrDeleteDocumentReferenceObject';
import type { CustomBreakpoints } from '../models/CustomBreakpoints';
import type { CustomPrimaryUser } from '../models/CustomPrimaryUser';
import type { CustomUser } from '../models/CustomUser';
import type { DailyNavGPCApproach } from '../models/DailyNavGPCApproach';
import type { DailyNavRecord } from '../models/DailyNavRecord';
import type { DailyNavRecordGenerateResponse } from '../models/DailyNavRecordGenerateResponse';
import type { DailyNavRecordUpdate } from '../models/DailyNavRecordUpdate';
import type { DashboardSmallUser } from '../models/DashboardSmallUser';
import type { DelegateDocumentRequest } from '../models/DelegateDocumentRequest';
import type { DelegateQuestionnaire } from '../models/DelegateQuestionnaire';
import type { DetailResponse } from '../models/DetailResponse';
import type { DismissAIFieldRequest } from '../models/DismissAIFieldRequest';
import type { DismissAIFieldResponse } from '../models/DismissAIFieldResponse';
import type { DocumentReferenceClassification } from '../models/DocumentReferenceClassification';
import type { DocumentReferenceCreateRequest } from '../models/DocumentReferenceCreateRequest';
import type { DocumentReferenceDeleteResponse } from '../models/DocumentReferenceDeleteResponse';
import type { DocumentReferenceObjectView } from '../models/DocumentReferenceObjectView';
import type { DocumentReferencesView } from '../models/DocumentReferencesView';
import type { DocumentRequestView } from '../models/DocumentRequestView';
import type { DraftFinalReportEmailRequest } from '../models/DraftFinalReportEmailRequest';
import type { DraftFinalReportEmailResponse } from '../models/DraftFinalReportEmailResponse';
import type { EdgarIssuerName } from '../models/EdgarIssuerName';
import type { EdgarIssuerNameUpdate } from '../models/EdgarIssuerNameUpdate';
import type { EffectiveTaxRateModel } from '../models/EffectiveTaxRateModel';
import type { EffectiveTaxRateWriteModel } from '../models/EffectiveTaxRateWriteModel';
import type { EnsureFulfillmentForAttioValuationRequest } from '../models/EnsureFulfillmentForAttioValuationRequest';
import type { EquityValue } from '../models/EquityValue';
import type { ExcelExportGet } from '../models/ExcelExportGet';
import type { ExcelExportsRequested } from '../models/ExcelExportsRequested';
import type { ExcelExportStartInputData } from '../models/ExcelExportStartInputData';
import type { ExtendedCompanyInfo } from '../models/ExtendedCompanyInfo';
import type { FileCreateRequest } from '../models/FileCreateRequest';
import type { FileCreateResponse } from '../models/FileCreateResponse';
import type { FileModel } from '../models/FileModel';
import type { FileStorageReferenceResponse } from '../models/FileStorageReferenceResponse';
import type { FileUpdate } from '../models/FileUpdate';
import type { FileUpdateRequestedFiles } from '../models/FileUpdateRequestedFiles';
import type { FileView } from '../models/FileView';
import type { FinancialStatementBasicData } from '../models/FinancialStatementBasicData';
import type { FinancialStatementFullRead } from '../models/FinancialStatementFullRead';
import type { FinancialStatementFullWrite } from '../models/FinancialStatementFullWrite';
import type { FinancialStatementSmall } from '../models/FinancialStatementSmall';
import type { FinancialStatementVersionValidator } from '../models/FinancialStatementVersionValidator';
import type { Firm } from '../models/Firm';
import type { FirmCompanies } from '../models/FirmCompanies';
import type { FirmCompaniesRequestsProgress } from '../models/FirmCompaniesRequestsProgress';
import type { FirmCompany } from '../models/FirmCompany';
import type { FirmCompanyMeasurementDate } from '../models/FirmCompanyMeasurementDate';
import type { FirmDailyNavConfigUpdate } from '../models/FirmDailyNavConfigUpdate';
import type { FirmDailyNavConfigVersion } from '../models/FirmDailyNavConfigVersion';
import type { FirmDefinitionListResponse } from '../models/FirmDefinitionListResponse';
import type { FirmDocumentCompaniesResponse } from '../models/FirmDocumentCompaniesResponse';
import type { FirmDocumentFilterOptionsResponse } from '../models/FirmDocumentFilterOptionsResponse';
import type { FirmDocumentFoldersResponse } from '../models/FirmDocumentFoldersResponse';
import type { FirmDocumentMeasurementDatesResponse } from '../models/FirmDocumentMeasurementDatesResponse';
import type { FirmDocumentReference } from '../models/FirmDocumentReference';
import type { FirmDocumentReferenceBulkDeleteRequest } from '../models/FirmDocumentReferenceBulkDeleteRequest';
import type { FirmDocumentReferenceBulkDeleteResponse } from '../models/FirmDocumentReferenceBulkDeleteResponse';
import type { FirmDocumentReferenceTransferRequest } from '../models/FirmDocumentReferenceTransferRequest';
import type { FirmDocumentReferenceTransferResponse } from '../models/FirmDocumentReferenceTransferResponse';
import type { FirmDocumentReferenceUpdateRequest } from '../models/FirmDocumentReferenceUpdateRequest';
import type { FirmDocumentRequestedFilesResponse } from '../models/FirmDocumentRequestedFilesResponse';
import type { FirmDocumentSuggestionsResponse } from '../models/FirmDocumentSuggestionsResponse';
import type { FirmRequestedDocumentModel } from '../models/FirmRequestedDocumentModel';
import type { FirmRequestsView } from '../models/FirmRequestsView';
import type { FirmStepper } from '../models/FirmStepper';
import type { FirmSummaryDefinition } from '../models/FirmSummaryDefinition';
import type { FirmSummaryRead } from '../models/FirmSummaryRead';
import type { FirmUserPermission } from '../models/FirmUserPermission';
import type { FolderModel } from '../models/FolderModel';
import type { FolderView } from '../models/FolderView';
import type { Fulfillment } from '../models/Fulfillment';
import type { FulfillmentAssignmentRule } from '../models/FulfillmentAssignmentRule';
import type { FulfillmentModelLeaderboardQuery } from '../models/FulfillmentModelLeaderboardQuery';
import type { Fund } from '../models/Fund';
import type { FundByMeasurementDate } from '../models/FundByMeasurementDate';
import type { FundDefinitionListResponse } from '../models/FundDefinitionListResponse';
import type { FundFamilyAccept } from '../models/FundFamilyAccept';
import type { FundMeasurementDateName } from '../models/FundMeasurementDateName';
import type { FundName } from '../models/FundName';
import type { FundSummary } from '../models/FundSummary';
import type { FundSummaryDefinition } from '../models/FundSummaryDefinition';
import type { GetAuditLogsResponse } from '../models/GetAuditLogsResponse';
import type { GlobalSummaryDefinition } from '../models/GlobalSummaryDefinition';
import type { GoogleCalendarEventsQuery } from '../models/GoogleCalendarEventsQuery';
import type { GPC } from '../models/GPC';
import type { GPCPeriods } from '../models/GPCPeriods';
import type { IndividualRequestedFile } from '../models/IndividualRequestedFile';
import type { InformationRequestStatus } from '../models/InformationRequestStatus';
import type { IntegrationMetadata } from '../models/IntegrationMetadata';
import type { Investment } from '../models/Investment';
import type { InvestmentCompanyInfo } from '../models/InvestmentCompanyInfo';
import type { JobStatusResponse } from '../models/JobStatusResponse';
import type { KeyDevelopmentList } from '../models/KeyDevelopmentList';
import type { LatestValuationExtractionRun } from '../models/LatestValuationExtractionRun';
import type { LookingGlassAvailableDate } from '../models/LookingGlassAvailableDate';
import type { LookingGlassSnapshot } from '../models/LookingGlassSnapshot';
import type { LookingGlassSummaryData } from '../models/LookingGlassSummaryData';
import type { MeasurementDateExistsReturn } from '../models/MeasurementDateExistsReturn';
import type { MeasurementDateExtended } from '../models/MeasurementDateExtended';
import type { MeasurementDateName } from '../models/MeasurementDateName';
import type { MeasurementDateRollover } from '../models/MeasurementDateRollover';
import type { MeasurementDateRolloverReturn } from '../models/MeasurementDateRolloverReturn';
import type { MergeProfileSave } from '../models/MergeProfileSave';
import type { MultiAllocationInputSerializer } from '../models/MultiAllocationInputSerializer';
import type { MutualFundFamily } from '../models/MutualFundFamily';
import type { MutualFundMarksResponse } from '../models/MutualFundMarksResponse';
import type { NewValuationAllocationVersion } from '../models/NewValuationAllocationVersion';
import type { Note } from '../models/Note';
import type { NoteGet } from '../models/NoteGet';
import type { NumberFriendlyCreateCompanyQuestion } from '../models/NumberFriendlyCreateCompanyQuestion';
import type { Portal } from '../models/Portal';
import type { PreFxPreviewRequest } from '../models/PreFxPreviewRequest';
import type { PreFxPreviewResponse } from '../models/PreFxPreviewResponse';
import type { PresignedURL } from '../models/PresignedURL';
import type { ProFormaCapTableModel } from '../models/ProFormaCapTableModel';
import type { RecalculatePublicCompsDependenciesRequest } from '../models/RecalculatePublicCompsDependenciesRequest';
import type { RecalculatePublicCompsDependenciesResponse } from '../models/RecalculatePublicCompsDependenciesResponse';
import type { RedelegateDocumentRequest } from '../models/RedelegateDocumentRequest';
import type { RedelegateQuestionnaire } from '../models/RedelegateQuestionnaire';
import type { RefreshComps } from '../models/RefreshComps';
import type { ReportBackupFile } from '../models/ReportBackupFile';
import type { ReportContact } from '../models/ReportContact';
import type { RetrieveDocumentExecutionSession } from '../models/RetrieveDocumentExecutionSession';
import type { RetrieveDocumentGenerationJob } from '../models/RetrieveDocumentGenerationJob';
import type { ScalarOpinionView } from '../models/ScalarOpinionView';
import type { Scenario } from '../models/Scenario';
import type { ScenarioValuesCalculation } from '../models/ScenarioValuesCalculation';
import type { SCIMConfigurationRead } from '../models/SCIMConfigurationRead';
import type { SCIMConfigurationUpdate } from '../models/SCIMConfigurationUpdate';
import type { SCIMTokenAction } from '../models/SCIMTokenAction';
import type { SCIMTokenCreateResponse } from '../models/SCIMTokenCreateResponse';
import type { SCIMTokenRead } from '../models/SCIMTokenRead';
import type { SetReadyForAudit } from '../models/SetReadyForAudit';
import type { SharesAcquisitionExclusion } from '../models/SharesAcquisitionExclusion';
import type { SharesSaleExclusion } from '../models/SharesSaleExclusion';
import type { SheetAttributeMapping } from '../models/SheetAttributeMapping';
import type { SheetAttributeMappingUpsert } from '../models/SheetAttributeMappingUpsert';
import type { SlimUserGenerationJob } from '../models/SlimUserGenerationJob';
import type { SocialLoginRequest } from '../models/SocialLoginRequest';
import type { SocialLoginResponse } from '../models/SocialLoginResponse';
import type { SpreadsheetNote } from '../models/SpreadsheetNote';
import type { SpreadsheetNoteGet } from '../models/SpreadsheetNoteGet';
import type { StartValuationExtractionResponse } from '../models/StartValuationExtractionResponse';
import type { SummaryDataResponse } from '../models/SummaryDataResponse';
import type { SummaryDefinitionOrder } from '../models/SummaryDefinitionOrder';
import type { SuperSearchResponse } from '../models/SuperSearchResponse';
import type { TableView } from '../models/TableView';
import type { TableViewListResponse } from '../models/TableViewListResponse';
import type { TaskDetailedProgress } from '../models/TaskDetailedProgress';
import type { TaskModel } from '../models/TaskModel';
import type { TenantEmailDiscoveryRequest } from '../models/TenantEmailDiscoveryRequest';
import type { TenantEmailDiscoveryResponse } from '../models/TenantEmailDiscoveryResponse';
import type { TenantInformation } from '../models/TenantInformation';
import type { TenantSlugDiscovery } from '../models/TenantSlugDiscovery';
import type { TenantSlugDiscoveryResponse } from '../models/TenantSlugDiscoveryResponse';
import type { TimeSeriesResponse } from '../models/TimeSeriesResponse';
import type { TokenExchangeRequest } from '../models/TokenExchangeRequest';
import type { TokenExchangeResponse } from '../models/TokenExchangeResponse';
import type { TOTPCreate } from '../models/TOTPCreate';
import type { TOTPDelete } from '../models/TOTPDelete';
import type { TOTPStatus } from '../models/TOTPStatus';
import type { TOTPUpdate } from '../models/TOTPUpdate';
import type { TOTPUpdateRequest } from '../models/TOTPUpdateRequest';
import type { TOTPVerify } from '../models/TOTPVerify';
import type { TransactionId } from '../models/TransactionId';
import type { UpdateCompanyQuestion } from '../models/UpdateCompanyQuestion';
import type { UpdateDecisionsView } from '../models/UpdateDecisionsView';
import type { UpdateDocumentAndQuestionnaireTasks } from '../models/UpdateDocumentAndQuestionnaireTasks';
import type { UpdateFirmQuestion } from '../models/UpdateFirmQuestion';
import type { UpdateFundOwnershipResponse } from '../models/UpdateFundOwnershipResponse';
import type { UpdateIndividualQuestion } from '../models/UpdateIndividualQuestion';
import type { UpdateScalarOpinionClientsAuthorized } from '../models/UpdateScalarOpinionClientsAuthorized';
import type { URL } from '../models/URL';
import type { UserFirmRole } from '../models/UserFirmRole';
import type { UserFulfillmentRequest } from '../models/UserFulfillmentRequest';
import type { UserNoteGet } from '../models/UserNoteGet';
import type { UserPermission } from '../models/UserPermission';
import type { UserPermissionWithPath } from '../models/UserPermissionWithPath';
import type { UserWithPermissions } from '../models/UserWithPermissions';
import type { ValuationAllocationModel } from '../models/ValuationAllocationModel';
import type { ValuationApproachModel } from '../models/ValuationApproachModel';
import type { ValuationExtractionStatus } from '../models/ValuationExtractionStatus';
import type { ValuationModel } from '../models/ValuationModel';
import type { ValuationOpinionModule } from '../models/ValuationOpinionModule';
import type { ValuationReportSelection } from '../models/ValuationReportSelection';
import type { WaterfallView } from '../models/WaterfallView';
import type { WorkboardDirectory } from '../models/WorkboardDirectory';
import type { WorkboardTask } from '../models/WorkboardTask';
import type { WorkboardTaskCalendarEventsQuery } from '../models/WorkboardTaskCalendarEventsQuery';
import type { WorkboardTaskOccurrence } from '../models/WorkboardTaskOccurrence';
import type { ZanbatoAskPricingResponse } from '../models/ZanbatoAskPricingResponse';
import type { ZanbatoBidPricingResponse } from '../models/ZanbatoBidPricingResponse';
import type { ZanbatoClosedTransactionsResponse } from '../models/ZanbatoClosedTransactionsResponse';
import type { ZanbatoMarksValuationResponse } from '../models/ZanbatoMarksValuationResponse';
import type { ZanbatoPricingResponse } from '../models/ZanbatoPricingResponse';
import type { ZanbatoReportedMarksResponse } from '../models/ZanbatoReportedMarksResponse';
import type { ZapierAuthTestResponse } from '../models/ZapierAuthTestResponse';
import type { ZapierSubscriptionCreate } from '../models/ZapierSubscriptionCreate';
import type { ZapierSubscriptionResponse } from '../models/ZapierSubscriptionResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ApiService {
  /**
   * @returns any
   * @throws ApiError
   */
  public static apiAblyTokenList(): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/ably-token',
    });
  }
  /**
   * @param data
   * @returns Scenario
   * @throws ApiError
   */
  public static apiAllocationScenarioAllocationResultsCreate(
    data: ScenarioValuesCalculation,
  ): CancelablePromise<Scenario> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/allocation-scenario/allocation-results',
      body: data,
    });
  }
  /**
   * @param data
   * @returns EquityValue
   * @throws ApiError
   */
  public static apiAllocationsCalculateBacksolveCreate(
    data: MultiAllocationInputSerializer,
  ): CancelablePromise<EquityValue> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/allocations/calculate-backsolve',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AllocationConclusionModel
   * @throws ApiError
   */
  public static apiAllocationsFinalUpdate(
    data: AllocationConclusionModel,
  ): CancelablePromise<AllocationConclusionModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/final',
      body: data,
    });
  }
  /**
   * @param data
   * @returns AllocationConclusionModel
   * @throws ApiError
   */
  public static apiAllocationsFinalPartialUpdate(
    data: AllocationConclusionModel,
  ): CancelablePromise<AllocationConclusionModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/final',
      body: data,
    });
  }
  /**
   * @param id
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsRead(
    id: string,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPartialUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/{id}',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPublishedUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/allocations/{id}/published',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * @param id
   * @param data
   * @returns AllocationModel
   * @throws ApiError
   */
  public static apiAllocationsPublishedPartialUpdate(
    id: string,
    data: AllocationModel,
  ): CancelablePromise<AllocationModel> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/allocations/{id}/published',
      path: {
        'id': id,
      },
      body: data,
    });
  }
  /**
   * Create a new analyst note.
   * POST /api/analyst-notes/
   * @param data
   * @returns UserNoteGet
   * @throws ApiError
   */
  public static apiAnalystNotesCreate(
    data: UserNoteGet,
  ): CancelablePromise<UserNoteGet> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/analyst-notes/',
      body: data,
    });
  }
  /**
   * Retrieve multiple analyst notes by their reference IDs and reference type.
   * POST /api/analyst-notes/bulk-history/
   * Response shape:
   * {
     * "<reference_id_as_string>": [<note_struct>, <note_struct>, ...]  // newest-first
     * }
     *
     * For reference_type 'wo', also accepts workboard_task_occurrence_keys with
     * "<workboard_task_id>:<occurrence_date>" response keys.
     * @returns any
     * @throws ApiError
     */
    public static apiAnalystNotesBulkHistoryCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/analyst-notes/bulk-history/',
      });
    }
    /**
     * Retrieve multiple analyst notes by their reference IDs and reference type.
     * POST /api/analyst-notes/bulk/
     * Returns a dictionary where keys are reference IDs (as strings) and values are note objects
     * in the same structure as returned by /dashboard/user/{id}/models/ endpoint.
     *
     * For reference_type 'wo', also accepts workboard_task_occurrence_keys:
     * [{ "workboard_task_id": 1, "occurrence_date": "2026-06-16" }, ...]
     * Keys for those lookups use "<workboard_task_id>:<occurrence_date>".
     * @returns any
     * @throws ApiError
     */
    public static apiAnalystNotesBulkCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/analyst-notes/bulk/',
      });
    }
    /**
     * Retrieve or update an analyst note by note ID.
     * GET /api/analyst-notes/{note_id}/ - Retrieve
     * PUT /api/analyst-notes/{note_id}/ - Update
     * @param noteId
     * @returns any
     * @throws ApiError
     */
    public static apiAnalystNotesRead(
      noteId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/analyst-notes/{note_id}/',
        path: {
          'note_id': noteId,
        },
      });
    }
    /**
     * Retrieve or update an analyst note by note ID.
     * GET /api/analyst-notes/{note_id}/ - Retrieve
     * PUT /api/analyst-notes/{note_id}/ - Update
     * @param noteId
     * @returns any
     * @throws ApiError
     */
    public static apiAnalystNotesUpdate(
      noteId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/analyst-notes/{note_id}/',
        path: {
          'note_id': noteId,
        },
      });
    }
    /**
     * Retrieve or update an analyst note by note ID.
     * GET /api/analyst-notes/{note_id}/ - Retrieve
     * PUT /api/analyst-notes/{note_id}/ - Update
     * @param noteId
     * @returns any
     * @throws ApiError
     */
    public static apiAnalystNotesPartialUpdate(
      noteId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/analyst-notes/{note_id}/',
        path: {
          'note_id': noteId,
        },
      });
    }
    /**
     * Retrieve or update an analyst note by note ID.
     * GET /api/analyst-notes/{note_id}/ - Retrieve
     * PUT /api/analyst-notes/{note_id}/ - Update
     * @param noteId
     * @returns void
     * @throws ApiError
     */
    public static apiAnalystNotesDelete(
      noteId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/analyst-notes/{note_id}/',
        path: {
          'note_id': noteId,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiAttioBulkConsultantsCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/bulk/consultants',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiAttioBulkDealsCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/bulk/deals',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiAttioBulkEngagementManagersCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/bulk/engagement-managers',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiAttioBulkValuationsCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/bulk/valuations',
      });
    }
    /**
     * Explicit endpoint to trigger fulfillment assignment automation after a stage update.
     * This avoids coupling automation dispatch to Attio PATCH payload shape/timing only.
     * @returns any
     * @throws ApiError
     */
    public static apiAttioFulfillmentAssignmentAutomationTriggerCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/fulfillment-assignment-automation/trigger',
      });
    }
    /**
     * Get Attio API configuration for a specific endpoint.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiAttioSettingsRead(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/attio/settings/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Returns a complete `AttioValuationDetailResponse` for a single valuation record.
     * This is meant to replace the frontend's N+1 related fetches inside `OperationsModal`.
     * @param valuationRecordId
     * @returns any
     * @throws ApiError
     */
    public static apiAttioValuationsFullDetailRead(
      valuationRecordId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/attio/valuations/full-detail/{valuation_record_id}',
        path: {
          'valuation_record_id': valuationRecordId,
        },
      });
    }
    /**
     * @param search Search query string
     * @param searchAll Search all valuations
     * @returns any
     * @throws ApiError
     */
    public static apiAttioValuationsSearchList(
      search: string,
      searchAll?: boolean,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/attio/valuations/search',
        query: {
          'search': search,
          'search_all': searchAll,
        },
      });
    }
    /**
     * Endpoint that fetches all valuations for a user and automatically loads
     * all related bulk data (consultants, managers, deals) and returns everything together.
     * @returns any
     * @throws ApiError
     */
    public static apiAttioValuationsWithBulkDataCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/valuations/with-bulk-data',
      });
    }
    /**
     * Handle GET requests to Attio API.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiAttioRead(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/attio/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Handle POST requests to Attio API.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiAttioCreate(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/attio/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Handle PUT requests to Attio API.
     * Unlike PATCH (which appends multiselect values), PUT overwrites/replaces them.
     * Use this to replace relationship fields like engagement_manager without appending.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiAttioUpdate(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/attio/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Handle PATCH requests to Attio API.
     * Invalidates cache for the updated resource.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiAttioPartialUpdate(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/attio/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Retrieve and update a specific sheet attribute mapping by its ID.
     * GET returns nested structure constructed by the serializer.
     * PUT allows updating the mapping, including accepting AI-generated mappings.
     * @param id A unique integer value identifying this Sheet Attribute Mapping.
     * @returns any
     * @throws ApiError
     */
    public static apiAttributeMappingsRead(
      id: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/attribute-mappings/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Retrieve and update a specific sheet attribute mapping by its ID.
     * GET returns nested structure constructed by the serializer.
     * PUT allows updating the mapping, including accepting AI-generated mappings.
     * @param id A unique integer value identifying this Sheet Attribute Mapping.
     * @returns any
     * @throws ApiError
     */
    public static apiAttributeMappingsUpdate(
      id: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/attribute-mappings/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Update a mapping by its ID.
     * Uses the same serializer as financials saving (SheetAttributeMappingUpsertSerializer).
     * @param id A unique integer value identifying this Sheet Attribute Mapping.
     * @param data
     * @returns SheetAttributeMapping Mapping updated successfully
     * @throws ApiError
     */
    public static apiAttributeMappingsPartialUpdate(
      id: number,
      data: SheetAttributeMappingUpsert,
    ): CancelablePromise<SheetAttributeMapping> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/attribute-mappings/{id}',
        path: {
          'id': id,
        },
        body: data,
        errors: {
          400: `Invalid request`,
          404: `Mapping not found`,
        },
      });
    }
    /**
     * Accept all AI-generated ordinates in a sheet attribute mapping
     * @param id
     * @returns SheetAttributeMapping All AI mappings accepted successfully
     * @throws ApiError
     */
    public static apiAttributeMappingsAcceptAllPartialUpdate(
      id: string,
    ): CancelablePromise<SheetAttributeMapping> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/attribute-mappings/{id}/accept-all',
        path: {
          'id': id,
        },
        errors: {
          400: `Mapping is not AI-generated`,
          404: `Mapping not found`,
        },
      });
    }
    /**
     * Decline (remove) all AI-generated ordinates in a sheet attribute mapping.
     * This removes all ordinates where is_ai_generated=True and is_accepted=False
     * from the grid_indicators (both columns and rows).
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiAttributeMappingsDeclineAllPartialUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/attribute-mappings/{id}/decline-all',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param pageNumber A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param domainArea
     * @param rootEntityId
     * @param rootEntityType
     * @param companyMeasurementDateId
     * @param company
     * @param firm
     * @param fund
     * @param startDate Filter logs created on or after this datetime. Format ISO_8601
     * @param endDate Filter logs created on or before this datetime. Format: ISO_8601
     * @param user Integer representing user responsible for the change
     * @param product
     * @returns GetAuditLogsResponse
     * @throws ApiError
     */
    public static apiAuditLogsList(
      pageNumber?: number,
      pageSize?: number,
      domainArea?: 'allocations' | 'valuations' | 'financials' | 'documents' | 'companies' | 'cap_table' | 'fulfillments' | 'funds' | 'firms' | 'fund_ownership',
      rootEntityId?: number,
      rootEntityType?: 'allocation' | 'valuation' | 'financial_statement' | 'measurement_date_documents' | 'company' | 'cap_table' | 'fund_ownership' | 'fulfillment' | 'fund',
      companyMeasurementDateId?: number,
      company?: number,
      firm?: number,
      fund?: number,
      startDate?: string,
      endDate?: string,
      user?: number,
      product?: 'portfolio-valuations' | 'workboard' | 'all',
    ): CancelablePromise<GetAuditLogsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/audit-logs',
        query: {
          'page_number': pageNumber,
          'page_size': pageSize,
          'domain_area': domainArea,
          'root_entity_id': rootEntityId,
          'root_entity_type': rootEntityType,
          'company_measurement_date_id': companyMeasurementDateId,
          'company': company,
          'firm': firm,
          'fund': fund,
          'start_date': startDate,
          'end_date': endDate,
          'user': user,
          'product': product,
        },
      });
    }
    /**
     * Get user's access scope for audit logs
     * Returns the scope of audit logs that the user has access to, including standalone companies and firms with their respective funds and companies.
     * @returns AuditLogsAccessResponse
     * @throws ApiError
     */
    public static apiAuditLogsAccessRead(): CancelablePromise<AuditLogsAccessResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/audit-logs/access',
        errors: {
          403: `Forbidden - The user does not have permission to access audit logs`,
        },
      });
    }
    /**
     * Accept or dismiss a single CitationReference by id (SCAL-8963).
     * PATCH /api/cap-tables/citations/<citation_id>/review
     * @param citationId
     * @param data
     * @returns CitationReviewResponse
     * @throws ApiError
     */
    public static apiCapTablesCitationsReviewPartialUpdate(
      citationId: string,
      data: CitationReviewRequest,
    ): CancelablePromise<CitationReviewResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/citations/{citation_id}/review',
        path: {
          'citation_id': citationId,
        },
        body: data,
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiCapTablesImportExtractedCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/cap-tables/import-extracted',
      });
    }
    /**
     * @param data
     * @returns ProFormaCapTableModel
     * @throws ApiError
     */
    public static apiCapTablesProFormaCreate(
      data: ProFormaCapTableModel,
    ): CancelablePromise<ProFormaCapTableModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/cap-tables/pro-forma',
        body: data,
      });
    }
    /**
     * @param securityId
     * @param data
     * @returns AcceptAIFieldResponse
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesAcceptAiFieldsPartialUpdate(
      securityId: string,
      data: AcceptAIFieldRequest,
    ): CancelablePromise<AcceptAIFieldResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/securities/{security_id}/accept-ai-fields',
        path: {
          'security_id': securityId,
        },
        body: data,
      });
    }
    /**
     * @param securityId
     * @param data
     * @returns DismissAIFieldResponse
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesDismissAiFieldsPartialUpdate(
      securityId: string,
      data: DismissAIFieldRequest,
    ): CancelablePromise<DismissAIFieldResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/securities/{security_id}/dismiss-ai-fields',
        path: {
          'security_id': securityId,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesRead(
      id: number,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesUpdate(
      id: number,
      data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/cap-tables/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesPartialUpdate(
      id: number,
      data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * Accept all AI field findings for every security in a cap table in a single request.
     * @param id
     * @returns AcceptAllAIFieldsResponse
     * @throws ApiError
     */
    public static apiCapTablesAcceptAllAiFieldsPartialUpdate(
      id: string,
    ): CancelablePromise<AcceptAllAIFieldsResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/accept-all-ai-fields',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Bulk accept/decline AI review fields across many securities in a cap table.
     * PATCH /api/cap-tables/<pk>/ai-review-batch
     * @param id
     * @param data
     * @returns AIReviewBatchResponse
     * @throws ApiError
     */
    public static apiCapTablesAiReviewBatchPartialUpdate(
      id: string,
      data: AIReviewBatchRequest,
    ): CancelablePromise<AIReviewBatchResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/ai-review-batch',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsRead(
      id: number,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/all-breakpoints',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CustomBreakpoints
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsUpdate(
      id: number,
      data: CustomBreakpoints,
    ): CancelablePromise<CustomBreakpoints> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/cap-tables/{id}/all-breakpoints',
        path: {
          'id': id,
        },
        body: data,
        errors: {
          400: `Bad Request`,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesAllBreakpointsPartialUpdate(
      id: number,
      data: CapTableDetailsModel,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/all-breakpoints',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * GET /api/cap-tables/<pk>/cash-flow-ledger
     * Returns combined saved + virtualized cash flow items for the cap table, sorted by date ascending.
     * @param id
     * @returns CashFlowLedgerItem
     * @throws ApiError
     */
    public static apiCapTablesCashFlowLedgerList(
      id: string,
    ): CancelablePromise<CashFlowLedgerItem> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/cash-flow-ledger',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns any Successfully saved cash flow ledger items
     * @throws ApiError
     */
    public static apiCapTablesCashFlowLedgerBulkSaveCreate(
      id: string,
      data: CashFlowLedgerBulkSave,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/cap-tables/{id}/cash-flow-ledger/bulk-save',
        path: {
          'id': id,
        },
        body: data,
        errors: {
          400: `Validation error`,
          404: `Cap Table not found`,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiCapTablesCheckAssociatedMeasurementDateList(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/check-associated-measurement-date',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @returns CapTableFundOwnership
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipRead(
      id: number,
    ): CancelablePromise<CapTableFundOwnership> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/fund-ownership',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @param data
     * @returns UpdateFundOwnershipResponse
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipUpdate(
      id: number,
      data: CapTableFundOwnership,
    ): CancelablePromise<UpdateFundOwnershipResponse> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/cap-tables/{id}/fund-ownership',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this fund ownership.
     * @param data
     * @returns CapTableFundOwnership
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipPartialUpdate(
      id: number,
      data: CapTableFundOwnership,
    ): CancelablePromise<CapTableFundOwnership> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/fund-ownership',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @returns UpdateFundOwnershipResponse
     * @throws ApiError
     */
    public static apiCapTablesFundOwnershipCopyFromPrimaryCreate(
      id: number,
    ): CancelablePromise<UpdateFundOwnershipResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/cap-tables/{id}/fund-ownership/copy-from-primary',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns AllocationCompanyModel
     * @throws ApiError
     */
    public static apiCapTablesGotFinalAllocationRead(
      id: string,
    ): CancelablePromise<AllocationCompanyModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/got-final-allocation',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Get gross IRR for a specific cap table and fund
     * Computes the gross IRR for the specified cap table and fund using the provided unrealized value at the given exit_date.
     * @param id A unique integer value identifying this cap table.
     * @param fund
     * @param unrealizedValue
     * @param exitDate
     * @returns CapTableGrossIRRResponse
     * @throws ApiError
     */
    public static apiCapTablesGrossIrrRead(
      id: number,
      fund: number,
      unrealizedValue: string,
      exitDate: string,
    ): CancelablePromise<CapTableGrossIRRResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/gross-irr',
        path: {
          'id': id,
        },
        query: {
          'fund': fund,
          'unrealized_value': unrealizedValue,
          'exit_date': exitDate,
        },
      });
    }
    /**
     * Get per-fund + firm gross IRR for a cap table
     * Computes per-fund and firm-total gross IRR for every fund with FundOwnershipDetail or non-excluded CashFlowLedgerItem on the cap_table. Unrealized values come from the latest published/final AllocationFundConclusion per fund.
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableGrossIRRsResponse
     * @throws ApiError
     */
    public static apiCapTablesGrossIrrsRead(
      id: number,
    ): CancelablePromise<CapTableGrossIRRsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/gross-irrs',
        path: {
          'id': id,
        },
      });
    }
    /**
     * pk here is id of the company measurement date we're querying a primary captable for
     * @param id A unique integer value identifying this cap table.
     * @returns CapTableDetailsModel
     * @throws ApiError
     */
    public static apiCapTablesPrimaryRead(
      id: number,
    ): CancelablePromise<CapTableDetailsModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/cap-tables/{id}/primary',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns CapTableSecurities
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesUpdate(
      id: string,
      data: CapTableSecurities,
    ): CancelablePromise<CapTableSecurities> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/cap-tables/{id}/securities',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns CapTableSecurities
     * @throws ApiError
     */
    public static apiCapTablesSecuritiesPartialUpdate(
      id: string,
      data: CapTableSecurities,
    ): CancelablePromise<CapTableSecurities> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/securities',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableModel
     * @throws ApiError
     */
    public static apiCapTablesToggleWaterfallVisibilityUpdate(
      id: number,
      data: CapTableModel,
    ): CancelablePromise<CapTableModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this cap table.
     * @param data
     * @returns CapTableModel
     * @throws ApiError
     */
    public static apiCapTablesToggleWaterfallVisibilityPartialUpdate(
      id: number,
      data: CapTableModel,
    ): CancelablePromise<CapTableModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/cap-tables/{id}/toggle-waterfall-visibility',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * Accept all pending AI citations for a specific document reference.
     * @returns any
     * @throws ApiError
     */
    public static apiCitationsAcceptAllPartialUpdate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/citations/accept-all/',
      });
    }
    /**
     * @param citationId
     * @returns void
     * @throws ApiError
     */
    public static apiCitationsDelete(
      citationId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/citations/{citation_id}/',
        path: {
          'citation_id': citationId,
        },
      });
    }
    /**
     * @param citationId
     * @returns any
     * @throws ApiError
     */
    public static apiCitationsAcceptanceUpdate(
      citationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/citations/{citation_id}/acceptance/',
        path: {
          'citation_id': citationId,
        },
      });
    }
    /**
     * @param citationId
     * @returns any
     * @throws ApiError
     */
    public static apiCitationsAcceptancePartialUpdate(
      citationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/citations/{citation_id}/acceptance/',
        path: {
          'citation_id': citationId,
        },
      });
    }
    /**
     * @param search A search term.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesList(
      search?: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/common-profiles/',
        query: {
          'search': search,
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns CommonCompanyProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesCreate(
      data: CommonCompanyProfileWrite,
    ): CancelablePromise<CommonCompanyProfile> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/common-profiles/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CommonCompanyProfileSuggestResponse
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesSuggestCreate(
      data: CommonCompanyProfileSuggest,
    ): CancelablePromise<CommonCompanyProfileSuggestResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/common-profiles/suggest/',
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this common company profile.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesRead(
      id: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/common-profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this common company profile.
     * @param data
     * @returns CommonCompanyProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesUpdate(
      id: number,
      data: CommonCompanyProfileWrite,
    ): CancelablePromise<CommonCompanyProfile> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/common-profiles/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this common company profile.
     * @param data
     * @returns CommonCompanyProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesPartialUpdate(
      id: number,
      data: CommonCompanyProfileWrite,
    ): CancelablePromise<CommonCompanyProfile> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/common-profiles/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this common company profile.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/companies/common-profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * List companies linked to a specific CommonCompanyProfile, with firm name.
     * @param id
     * @returns CommonProfileCompany
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesCompaniesList(
      id: string,
    ): CancelablePromise<Array<CommonProfileCompany>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/common-profiles/{id}/companies/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * List all EdgarIssuerName records linked to a specific CommonCompanyProfile.
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesEdgarIssuerNamesList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<EdgarIssuerName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/common-profiles/{id}/edgar-issuer-names/',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this common company profile.
     * @param data
     * @returns CommonCompanyProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilesMergeCreate(
      id: number,
      data: MergeProfileSave,
    ): CancelablePromise<CommonCompanyProfile> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/common-profiles/{id}/merge/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * Search all EdgarIssuerName records. Pass ?unlinked=true to filter to unmatched only.
     * @param search A search term.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesEdgarIssuerNamesList(
      search?: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<EdgarIssuerName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/edgar-issuer-names/',
        query: {
          'search': search,
          'page': page,
        },
      });
    }
    /**
     * Update (link or unlink) a single EdgarIssuerName record.
     * @param id A unique integer value identifying this edgar issuer name.
     * @param data
     * @returns EdgarIssuerNameUpdate
     * @throws ApiError
     */
    public static apiCompaniesEdgarIssuerNamesPartialUpdate(
      id: number,
      data: EdgarIssuerNameUpdate,
    ): CancelablePromise<EdgarIssuerNameUpdate> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/edgar-issuer-names/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesFiscalEndDatesRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/fiscal-end-dates/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * List all MutualFundFamily records or create a new one.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesMutualFundFamiliesList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<MutualFundFamily>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/mutual-fund-families/',
        query: {
          'page': page,
        },
      });
    }
    /**
     * List all MutualFundFamily records or create a new one.
     * @param data
     * @returns MutualFundFamily
     * @throws ApiError
     */
    public static apiCompaniesMutualFundFamiliesCreate(
      data: MutualFundFamily,
    ): CancelablePromise<MutualFundFamily> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/mutual-fund-families/',
        body: data,
      });
    }
    /**
     * Returns prefix-clustered suggestions for unmatched EdgarIssuerName fund_names.
     * Query params:
     * prefix_len (int, default 12) - characters to use for grouping
     * min_count  (int, default 2)  - minimum group size to include
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesMutualFundFamiliesSuggestionsList(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/mutual-fund-families/suggestions/',
      });
    }
    /**
     * Creates a MutualFundFamily from a suggestion and assigns matching issuer names.
     * @param data
     * @returns MutualFundFamily
     * @throws ApiError
     */
    public static apiCompaniesMutualFundFamiliesSuggestionsAcceptCreate(
      data: FundFamilyAccept,
    ): CancelablePromise<MutualFundFamily> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/mutual-fund-families/suggestions/accept/',
        body: data,
      });
    }
    /**
     * Extract tables from specified PDF pages and return as Excel data.
     * @param companyId
     * @param fileId
     * @param data
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompaniesDocumentsConversionCreate(
      companyId: string,
      fileId: string,
      data: {
        /**
         * List of page numbers to extract tables from
         */
        page_numbers: Array<number>;
      },
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{company_id}/documents/{file_id}/conversion',
        path: {
          'company_id': companyId,
          'file_id': fileId,
        },
        body: data,
        errors: {
          400: `Bad Request`,
          404: `File Not Found`,
          500: `Internal Server Error`,
        },
      });
    }
    /**
     * @param companyPk
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationValuesRead(
      companyPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{company_pk}/allocation-values',
        path: {
          'company_pk': companyPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesRead(
      id: number,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns Company
     * @throws ApiError
     */
    public static apiCompaniesPartialUpdate(
      id: number,
      data: Company,
    ): CancelablePromise<Company> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/companies/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAllocationsList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<AllocationName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/allocations',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesAssetSignedUrlRead(
      id: string,
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/asset-signed-url/{file_type}',
        path: {
          'id': id,
          'file_type': fileType,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesCapIqCacheRefreshCreate(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{id}/cap-iq-cache/refresh',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyCapIQFundingRounds
     * @throws ApiError
     */
    public static apiCompaniesCapIqFundingRoundsRead(
      id: number,
    ): CancelablePromise<CompanyCapIQFundingRounds> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-iq-funding-rounds',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyCapIQOverview
     * @throws ApiError
     */
    public static apiCompaniesCapIqOverviewRead(
      id: number,
    ): CancelablePromise<CompanyCapIQOverview> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-iq-overview/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @param mp Measurement date ID
     * @param cmd Command ID for measurement date
     * @param includeConvertibleNotes Include convertible notes in the response
     * @returns CapTableName
     * @throws ApiError
     */
    public static apiCompaniesCapTablesList(
      id: string,
      page?: number,
      mp?: number,
      cmd?: number,
      includeConvertibleNotes: boolean = false,
    ): CancelablePromise<Array<CapTableName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/cap-tables',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'mp': mp,
          'cmd': cmd,
          'include_convertible_notes': includeConvertibleNotes,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyLinkProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfileUpdate(
      id: number,
      data: CompanyLinkProfile,
    ): CancelablePromise<CompanyLinkProfile> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}/common-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyLinkProfile
     * @throws ApiError
     */
    public static apiCompaniesCommonProfilePartialUpdate(
      id: number,
      data: CompanyLinkProfile,
    ): CancelablePromise<CompanyLinkProfile> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/common-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns ConfirmProfileBody
     * @throws ApiError
     */
    public static apiCompaniesConfirmProfilePartialUpdate(
      id: number,
      data: ConfirmProfileBody,
    ): CancelablePromise<ConfirmProfileBody> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/confirm-profile',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param basePeriod Aggregation period: 'quarter' or 'year'
     * @returns CompanyFinancialHistory
     * @throws ApiError
     */
    public static apiCompaniesFinancialHistoryRead(
      id: number,
      basePeriod: 'quarter' | 'year' = 'quarter',
    ): CancelablePromise<CompanyFinancialHistory> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/financial-history',
        path: {
          'id': id,
        },
        query: {
          'base_period': basePeriod,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns CompanyFundingRounds
     * @throws ApiError
     */
    public static apiCompaniesFundingRoundsRead(
      id: number,
    ): CancelablePromise<CompanyFundingRounds> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/funding-rounds',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiCompaniesHasSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/has-summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param categories Cap IQ key dev category codes, e.g. C2,C3. Defaults to C2 with fallback.
     * @param startRank
     * @param endRank
     * @returns KeyDevelopmentList
     * @throws ApiError
     */
    public static apiCompaniesKeyDevelopmentsRead(
      id: number,
      categories?: Array<string>,
      startRank: number = 1,
      endRank: number = 100,
    ): CancelablePromise<KeyDevelopmentList> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/key-developments',
        path: {
          'id': id,
        },
        query: {
          'categories': categories,
          'start_rank': startRank,
          'end_rank': endRank,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsInvestedCapitalRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/invested-capital',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsMoicRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/moic',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate Date in YYYY-MM-DD format. If not provided, uses the latest measurement date.
     * @returns TimeSeriesResponse
     * @throws ApiError
     */
    public static apiCompaniesMetricsUnrealizedValueRead(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<TimeSeriesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/metrics/unrealized-value',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns MutualFundMarksResponse
     * @throws ApiError
     */
    public static apiCompaniesMutualFundMarksRead(
      id: number,
    ): CancelablePromise<MutualFundMarksResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/mutual-fund-marks/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param pageAfter Cursor for the next page of results
     * @param pageBefore Cursor for the previous page of results
     * @param releaseDateStart Filter news on or after this date (YYYY-MM-DD)
     * @param releaseDateEnd Filter news on or before this date (YYYY-MM-DD)
     * @param pageSize Number of results per page
     * @returns CommonCompanyProfileNews
     * @throws ApiError
     */
    public static apiCompaniesNewsRead(
      id: number,
      pageAfter?: string,
      pageBefore?: string,
      releaseDateStart?: string,
      releaseDateEnd?: string,
      pageSize: number = 20,
    ): CancelablePromise<CommonCompanyProfileNews> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/news',
        path: {
          'id': id,
        },
        query: {
          'page_after': pageAfter,
          'page_before': pageBefore,
          'release_date_start': releaseDateStart,
          'release_date_end': releaseDateEnd,
          'page_size': pageSize,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns void
     * @throws ApiError
     */
    public static apiCompaniesSacraCacheRefreshCreate(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/companies/{id}/sacra-cache/refresh',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Returns per-fund investments plus per-security CFL rollups for a company
     * at a specific measurement date. The response is a dict with three keys:
     * ``funds`` (list of investment rollups), ``cfl_totals_by_fund_no_security``
     * (fund_slug -> CFL bucket for NULL-security rows), and
     * ``cfl_totals_by_fund_security`` (fund_slug -> security_id -> CFL bucket).
     * @param id
     * @param mdId
     * @returns CompanySummaryResponse Per-fund investments + per-security CFL rollups for the company at this measurement date.
     * @throws ApiError
     */
    public static apiCompaniesSummaryRead(
      id: string,
      mdId: string,
    ): CancelablePromise<CompanySummaryResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/summary/{md_id}',
        path: {
          'id': id,
          'md_id': mdId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @param data
     * @returns CompanyQuestionSync
     * @throws ApiError
     */
    public static apiCompaniesSyncCompanyQuestionsPartialUpdate(
      id: number,
      data: CompanyQuestionSync,
    ): CancelablePromise<CompanyQuestionSync> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/companies/{id}/sync-company-questions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoAskPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoAskPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoAskPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-ask-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoBidPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoBidPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoBidPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-bid-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoClosedTransactionsResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoClosedTransactionsRead(
      id: number,
    ): CancelablePromise<ZanbatoClosedTransactionsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-closed-transactions',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoMarksValuationResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoMarksValuationRead(
      id: number,
    ): CancelablePromise<ZanbatoMarksValuationResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-marks-valuation',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoPricingResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoPricingRead(
      id: number,
    ): CancelablePromise<ZanbatoPricingResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-pricing',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company.
     * @returns ZanbatoReportedMarksResponse
     * @throws ApiError
     */
    public static apiCompaniesZanbatoReportedMarksRead(
      id: number,
    ): CancelablePromise<ZanbatoReportedMarksResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/companies/{id}/zanbato-reported-marks',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Retrieve a company measurement date by attio_valuation_id.
     * This is useful for finding the measurement date when we have the attio_valuation_id from query params.
     * If multiple records exist with the same attio_valuation_id, returns the most recent one.
     * @param attioValuationId Attio valuation ID
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesRead(
      attioValuationId: string,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/',
        query: {
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesRead1(
      id: number,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesPartialUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/company-measurement-dates/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param date
     * @returns MeasurementDateExistsReturn
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesExistsRead(
      id: string,
      date: string,
    ): CancelablePromise<MeasurementDateExistsReturn> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{id}/exists/{date}/',
        path: {
          'id': id,
          'date': date,
        },
      });
    }
    /**
     * Toggle the is_ready field on a CompanyMeasurementDate.
     * Only staff or superusers can toggle this field.
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesToggleReadyUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/company-measurement-dates/{id}/toggle-ready/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * Toggle the is_ready field on a CompanyMeasurementDate.
     * Only staff or superusers can toggle this field.
     * @param id A unique integer value identifying this company measurement date.
     * @param data
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesToggleReadyPartialUpdate(
      id: number,
      data: CompanyMeasurementDateModel,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/company-measurement-dates/{id}/toggle-ready/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @returns CompanyMeasurementDateModel
     * @throws ApiError
     */
    public static apiCompanyMeasurementDatesByMeasurementDateRead(
      mdPk: string,
    ): CancelablePromise<CompanyMeasurementDateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-measurement-dates/{md_pk}/by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param companyId
     * @param search A search term.
     * @returns CustomPrimaryUser
     * @throws ApiError
     */
    public static apiCompanyUsersRead(
      companyId: string,
      search?: string,
    ): CancelablePromise<Array<CustomPrimaryUser>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company-users/{company_id}',
        path: {
          'company_id': companyId,
        },
        query: {
          'search': search,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns ApplyCapTableGenerationJob
     * @throws ApiError
     */
    public static apiCompanyCapTablesApplyGenerationJobCreate(
      companyId: string,
      data: ApplyCapTableGenerationJob,
    ): CancelablePromise<ApplyCapTableGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/company/{company_id}/cap-tables/apply-generation-job',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @returns any
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsList(
      companyId: string,
      page?: number,
      pageSize?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<RetrieveDocumentGenerationJob>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
          'page_size': pageSize,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsNewCreate(
      companyId: string,
      data: ApiCreateDocumentGenerationJob,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/company/{company_id}/document-generation-jobs/new',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param jobId
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsRead(
      companyId: string,
      jobId: string,
    ): CancelablePromise<RetrieveDocumentGenerationJob> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs/{job_id}',
        path: {
          'company_id': companyId,
          'job_id': jobId,
        },
      });
    }
    /**
     * Get document execution sessions for a specific job, optionally creating File instances
     * @param companyId
     * @param jobId
     * @param page A page number within the paginated result set.
     * @param createFileReferences
     * @param measurementDateId
     * @param referenceObjectType
     * @returns RetrieveDocumentExecutionSession
     * @throws ApiError
     */
    public static apiCompanyDocumentGenerationJobsDocumentExecutionSessionsList(
      companyId: string,
      jobId: string,
      page?: number,
      createFileReferences?: boolean,
      measurementDateId?: number,
      referenceObjectType: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs' = 'ct',
    ): CancelablePromise<Array<RetrieveDocumentExecutionSession>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/company/{company_id}/document-generation-jobs/{job_id}/document-execution-sessions',
        path: {
          'company_id': companyId,
          'job_id': jobId,
        },
        query: {
          'page': page,
          'create_file_references': createFileReferences,
          'measurement_date_id': measurementDateId,
          'reference_object_type': referenceObjectType,
        },
        errors: {
          404: `Job not found`,
        },
      });
    }
    /**
     * @param data
     * @returns InformationRequestStatus
     * @throws ApiError
     */
    public static apiCreateInformationRequestStatusCreate(
      data: InformationRequestStatus,
    ): CancelablePromise<InformationRequestStatus> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/create-information-request-status',
        body: data,
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns TaskDetailedProgress
     * @throws ApiError
     */
    public static apiCreateInformationRequestUpdate(
      informationRequestStatusId: string,
      data: CreateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<Array<TaskDetailedProgress>> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/create-information-request/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns CreateDocumentAndQuestionnaireTasks
     * @throws ApiError
     */
    public static apiCreateInformationRequestPartialUpdate(
      informationRequestStatusId: string,
      data: CreateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<CreateDocumentAndQuestionnaireTasks> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/create-information-request/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * The GPC approaches (and their non-deleted comps) for one company
     * measurement date, offered up as the source list for the "copy from GPC"
     * Daily NAV comp picker. Scoped solely by the company measurement date --
     * which already identifies the company and firm -- so firm/company ids are
     * not part of the route. Firm access is enforced off the CMD's owning firm.
     * @param companyMeasurementDateId
     * @param page A page number within the paginated result set.
     * @returns DailyNavGPCApproach
     * @throws ApiError
     */
    public static apiDailyNavCompanyMeasurementDatesGpcApproachesList(
      companyMeasurementDateId: string,
      page?: number,
    ): CancelablePromise<Array<DailyNavGPCApproach>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/daily-nav/company-measurement-dates/{company_measurement_date_id}/gpc-approaches/',
        path: {
          'company_measurement_date_id': companyMeasurementDateId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this daily nav record.
     * @param data
     * @returns DailyNavRecordUpdate
     * @throws ApiError
     */
    public static apiDailyNavPartialUpdate(
      id: number,
      data: DailyNavRecordUpdate,
    ): CancelablePromise<DailyNavRecordUpdate> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/daily-nav/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param data
     * @returns Create409Report
     * @throws ApiError
     */
    public static apiDashboardCreate(
      data: Create409Report,
    ): CancelablePromise<Create409Report> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard',
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionRead(
      questionId: string,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionUpdate(
      questionId: string,
      data: UpdateCompanyQuestion,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionPartialUpdate(
      questionId: string,
      data: UpdateCompanyQuestion,
    ): CancelablePromise<UpdateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyQuestionDelete(
      questionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/companies/company-question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentRead(
      requestedDocumentId: string,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentUpdate(
      requestedDocumentId: string,
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentPartialUpdate(
      requestedDocumentId: string,
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompaniesCompanyRequestedDocumentDelete(
      requestedDocumentId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/companies/company-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param data
     * @returns AddBulkDashboardUser
     * @throws ApiError
     */
    public static apiDashboardCompanyAddBulkUserCreate(
      data: AddBulkDashboardUser,
    ): CancelablePromise<AddBulkDashboardUser> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/add-bulk-user/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns AddNewDashboardUser
     * @throws ApiError
     */
    public static apiDashboardCompanyAddUserCreate(
      data: AddNewDashboardUser,
    ): CancelablePromise<AddNewDashboardUser> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/add-user/',
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns UpdateScalarOpinionClientsAuthorized
     * @throws ApiError
     */
    public static apiDashboardCompanyApproveForClientsUpdate(
      cmdId: string,
      data: UpdateScalarOpinionClientsAuthorized,
    ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns UpdateScalarOpinionClientsAuthorized
     * @throws ApiError
     */
    public static apiDashboardCompanyApproveForClientsPartialUpdate(
      cmdId: string,
      data: UpdateScalarOpinionClientsAuthorized,
    ): CancelablePromise<UpdateScalarOpinionClientsAuthorized> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/company/approve-for-clients/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param data
     * @returns NumberFriendlyCreateCompanyQuestion
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateQuestionsCreate(
      data: NumberFriendlyCreateCompanyQuestion,
    ): CancelablePromise<NumberFriendlyCreateCompanyQuestion> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/create-questions/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CompanyRequestedDocumentModel
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateRequestedDocumentsCreate(
      data: CompanyRequestedDocumentModel,
    ): CancelablePromise<CompanyRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/create-requested-documents/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns AddOrRemoveRequestItems
     * @throws ApiError
     */
    public static apiDashboardCompanyModifyExistingRequestCreate(
      data: AddOrRemoveRequestItems,
    ): CancelablePromise<AddOrRemoveRequestItems> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/modify-existing-request/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CompanyPrimaryContact
     * @throws ApiError
     */
    public static apiDashboardCompanyPrimaryContactCreate(
      data: CompanyPrimaryContact,
    ): CancelablePromise<CompanyPrimaryContact> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/primary-contact/',
        body: data,
      });
    }
    /**
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCompanyRead(
      companyId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ScalarOpinionView>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns CreateCompanyInformationRequest
     * @throws ApiError
     */
    public static apiDashboardCompanyCreateInformationRequestCreate(
      companyId: string,
      data: CreateCompanyInformationRequest,
    ): CancelablePromise<CreateCompanyInformationRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/{company_id}/create-information-request/',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * Override list to return enhanced fulfillment data with user details
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentList(
      companyId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<Fulfillment>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentCreate(
      companyId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentRead(
      companyId: string,
      attioValuationId: string,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentUpdate(
      companyId: string,
      attioValuationId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @param data
     * @returns Fulfillment
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentPartialUpdate(
      companyId: string,
      attioValuationId: string,
      data: Fulfillment,
    ): CancelablePromise<Fulfillment> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
        body: data,
      });
    }
    /**
     * @param companyId
     * @param attioValuationId
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardCompanyOperationsFulfillmentDelete(
      companyId: string,
      attioValuationId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/company/{company_id}/operations/fulfillment/{attio_valuation_id}/',
        path: {
          'company_id': companyId,
          'attio_valuation_id': attioValuationId,
        },
      });
    }
    /**
     * @param companyId
     * @returns CompanyRequestedInformation
     * @throws ApiError
     */
    public static apiDashboardCompanyRequestedInformationRead(
      companyId: string,
    ): CancelablePromise<CompanyRequestedInformation> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/company/{company_id}/requested-information',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param cmdId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardCurrentInformationRequestsRead(
      cmdId: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/current-information-requests/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardDownloadFinalReportPdfRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/download-final-report-pdf/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardDownloadValuationReportRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/download-valuation-report/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesList(): CancelablePromise<Array<FulfillmentAssignmentRule>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/fulfillment-assignment-rules/',
      });
    }
    /**
     * @param data
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesCreate(
      data: FulfillmentAssignmentRule,
    ): CancelablePromise<FulfillmentAssignmentRule> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/fulfillment-assignment-rules/',
        body: data,
      });
    }
    /**
     * @param data
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesPreview(
      data: FulfillmentAssignmentRule,
    ): CancelablePromise<FulfillmentAssignmentRule> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/fulfillment-assignment-rules/preview/',
        body: data,
      });
    }
    /**
     * @param id
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesRead(
      id: string,
    ): CancelablePromise<FulfillmentAssignmentRule> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesUpdate(
      id: string,
      data: FulfillmentAssignmentRule,
    ): CancelablePromise<FulfillmentAssignmentRule> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns FulfillmentAssignmentRule
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesPartialUpdate(
      id: string,
      data: FulfillmentAssignmentRule,
    ): CancelablePromise<FulfillmentAssignmentRule> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardFulfillmentAssignmentRulesDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/fulfillment-assignment-rules/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGenerateWorkboardImageSignedUrlRead(
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/generate-workboard-image-signed-url/{file_type}',
        path: {
          'file_type': fileType,
        },
      });
    }
    /**
     * @param timeMin
     * @param timeMax
     * @param maxResults
     * @returns GoogleCalendarEventsQuery
     * @throws ApiError
     */
    public static apiDashboardGoogleCalendarEventsList(
      timeMin: string,
      timeMax?: string | null,
      maxResults: number = 100,
    ): CancelablePromise<Array<GoogleCalendarEventsQuery>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/google-calendar/events',
        query: {
          'time_min': timeMin,
          'time_max': timeMax,
          'max_results': maxResults,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGpcCompsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<GPCPeriods>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/gpc-comps',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns GPCPeriods
     * @throws ApiError
     */
    public static apiDashboardGpcCompsCreate(
      data: GPCPeriods,
    ): CancelablePromise<GPCPeriods> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/gpc-comps',
        body: data,
      });
    }
    /**
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardGpcCompsDelete(): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/gpc-comps',
      });
    }
    /**
     * GraphQL proxy to Alexandria, keeping the x-api-key server-side.
     * Accepts a standard GraphQL POST body ({"query": "...", "variables": {...}})
     * and returns Alexandria's response verbatim, including GraphQL "errors",
     * so the frontend keeps normal GraphQL semantics.
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardMarketDataGraphqlCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/market-data/graphql',
      });
    }
    /**
     * @param companyId
     * @param data
     * @returns FileStorageReferenceResponse
     * @throws ApiError
     */
    public static apiDashboardOperationsCompaniesFileStorageReferencePartialUpdate(
      companyId: string,
      data: CompanyFileStorageReferenceUpdate,
    ): CancelablePromise<FileStorageReferenceResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/operations/companies/{company_id}/file-storage-reference/',
        path: {
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns FileStorageReferenceResponse
     * @throws ApiError
     */
    public static apiDashboardOperationsCompanyMeasurementDatesFileStorageReferencePartialUpdate(
      cmdId: string,
      data: CompanyMeasurementDateFileStorageReferenceUpdate,
    ): CancelablePromise<FileStorageReferenceResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/operations/company-measurement-dates/{cmd_id}/file-storage-reference/',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardOperationsCompanyMeasurementDatesSyncCompanyDocsCreate(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/operations/company-measurement-dates/{cmd_id}/sync-company-docs/',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * Create or resolve Company, MeasurementDate, and CompanyMeasurementDate from Attio valuation
     * context, then get_or_create Fulfillment for that CMD.
     * Optional fulfillment fields are applied as a partial update.
     * @param data
     * @returns EnsureFulfillmentForAttioValuationRequest
     * @throws ApiError
     */
    public static apiDashboardOperationsEnsureFulfillmentForAttioValuationCreate(
      data: EnsureFulfillmentForAttioValuationRequest,
    ): CancelablePromise<EnsureFulfillmentForAttioValuationRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/operations/ensure-fulfillment-for-attio-valuation/',
        body: data,
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns WorkboardDirectory
     * @throws ApiError
     */
    public static apiDashboardOperationsReportFilesWorkboardDirectoriesList(
      page?: number,
    ): CancelablePromise<Array<WorkboardDirectory>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/report-files/workboard-directories/',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns ReportBackupFile
     * @throws ApiError
     */
    public static apiDashboardOperationsReportFilesWorkboardFilesList(
      page?: number,
    ): CancelablePromise<Array<ReportBackupFile>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/report-files/workboard-files/',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param runId
     * @returns ValuationExtractionStatus
     * @throws ApiError
     */
    public static apiDashboardOperationsValuationExtractionRead(
      runId: string,
    ): CancelablePromise<ValuationExtractionStatus> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/valuation-extraction/{run_id}/',
        path: {
          'run_id': runId,
        },
      });
    }
    /**
     * @param valuationId
     * @param page A page number within the paginated result set.
     * @returns LatestValuationExtractionRun
     * @throws ApiError
     */
    public static apiDashboardOperationsValuationsExtractionRunsLatestList(
      valuationId: string,
      page?: number,
    ): CancelablePromise<LatestValuationExtractionRun> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/valuations/{valuation_id}/extraction-runs/latest/',
        path: {
          'valuation_id': valuationId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns StartValuationExtractionResponse
     * @throws ApiError
     */
    public static apiDashboardOperationsValuationsExtractionCreate(
      valuationId: string,
      data: StartValuationExtractionResponse,
    ): CancelablePromise<StartValuationExtractionResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/operations/valuations/{valuation_id}/extraction/',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param valuationId
     * @param page A page number within the paginated result set.
     * @returns ValuationReportSelection
     * @throws ApiError
     */
    public static apiDashboardOperationsValuationsReportSelectionList(
      valuationId: string,
      page?: number,
    ): CancelablePromise<ValuationReportSelection> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/valuations/{valuation_id}/report-selection/',
        path: {
          'valuation_id': valuationId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns ValuationReportSelection
     * @throws ApiError
     */
    public static apiDashboardOperationsValuationsReportSelectionUpdate(
      valuationId: string,
      data: ValuationReportSelection,
    ): CancelablePromise<ValuationReportSelection> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/operations/valuations/{valuation_id}/report-selection/',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns DraftFinalReportEmailResponse
     * @throws ApiError
     */
    public static apiDashboardOperationsDraftFinalReportEmailCreate(
      cmdId: string,
      data: DraftFinalReportEmailRequest,
    ): CancelablePromise<DraftFinalReportEmailResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/operations/{cmd_id}/draft-final-report-email/',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param page A page number within the paginated result set.
     * @returns ReportContact
     * @throws ApiError
     */
    public static apiDashboardOperationsReportContactsList(
      cmdId: string,
      page?: number,
    ): CancelablePromise<Array<ReportContact>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/{cmd_id}/report-contacts/',
        path: {
          'cmd_id': cmdId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param cmdId
     * @param page A page number within the paginated result set.
     * @returns ReportBackupFile
     * @throws ApiError
     */
    public static apiDashboardOperationsReportFilesS3SearchList(
      cmdId: string,
      page?: number,
    ): CancelablePromise<Array<ReportBackupFile>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/operations/{cmd_id}/report-files/s3-search/',
        path: {
          'cmd_id': cmdId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardPublicCompaniesCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/public-companies',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardScalarOpinionsImportExtractedCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/scalar-opinions/import-extracted',
      });
    }
    /**
     * Get all fulfillments where the specified users are reviewers or preparers across all companies,
     * or fulfillments with no assigned reviewers/preparers, for the Model Reviewer/Preparer Dashboard
     *
     * Request Body:
     * - preparer_ids: List of preparer user IDs (optional). Example: [1, 2, 3]
     * - reviewer_ids: List of reviewer user IDs (optional). Example: [1, 2, 3]
     * - status_filter: Filter by assignment ('assigned', 'unassigned', or 'all')
     * - 'assigned': Returns fulfillments with at least one reviewer or preparer
     * - 'unassigned': Returns fulfillments with no reviewers/preparers assigned
     * - 'all': Returns all fulfillments
     * - Default: 'all'
     * - from_date: Filter by fulfillment creation date (optional). Example: '2026-01-01' (YYYY-MM-DD)
     * - to_date: Filter by fulfillment creation date (optional). Example: '2026-01-31' (YYYY-MM-DD)
     * - company: Filter by company name (optional). Example: 'Microsoft'
     *
     * Returns fulfillments that either:
     * - Have any of the specified users as reviewers or preparers (when status_filter is 'assigned' or 'all'), OR
     * - Have no assigned reviewers and no assigned preparers (when status_filter is 'unassigned', or included in 'all' with user IDs)
     * @param data
     * @returns UserFulfillmentRequest
     * @throws ApiError
     */
    public static apiDashboardUserModelsCreate(
      data: UserFulfillmentRequest,
    ): CancelablePromise<UserFulfillmentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/user/models/',
        body: data,
      });
    }
    /**
     * Distinct fulfillment model counts per user (reviewer or preparer) for the workboard
     * leaderboard. All-time requests only include users with at least 50 assigned models.
     * Date-filtered requests include every active user with at least one matching model.
     * Includes SLC and historic (non-Attio) models; excludes deleted fulfillments and
     * null model_status rows. Does not return full model payloads.
     *
     * Query params (optional, independent of workboard model table filters):
     * - from_date: Filter by fulfillment supporting_due_date (YYYY-MM-DD, inclusive)
     * - to_date: Filter by fulfillment supporting_due_date (YYYY-MM-DD, inclusive)
     * When either date is provided, fulfillments with null supporting_due_date are excluded
     * and the 50-model minimum is not applied. Omit both for all-time counts.
     * @param fromDate
     * @param toDate
     * @returns FulfillmentModelLeaderboardQuery
     * @throws ApiError
     */
    public static apiDashboardUserModelsLeaderboardList(
      fromDate?: string | null,
      toDate?: string | null,
    ): CancelablePromise<Array<FulfillmentModelLeaderboardQuery>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/user/models/leaderboard/',
        query: {
          'from_date': fromDate,
          'to_date': toDate,
        },
      });
    }
    /**
     * @returns WorkboardTask
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksList(): CancelablePromise<Array<WorkboardTask>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard-tasks/',
      });
    }
    /**
     * @param data
     * @returns WorkboardTask
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksCreate(
      data: WorkboardTask,
    ): CancelablePromise<WorkboardTask> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/workboard-tasks/',
        body: data,
      });
    }
    /**
     * @param timeMin
     * @param timeMax
     * @param userIds Optional user IDs from the active workboard view. When provided, only tasks with an assignee or task manager in this list are returned. When omitted, only fully unassigned tasks (no assignees and no task managers) are returned.
     * @returns WorkboardTaskCalendarEventsQuery
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksCalendarEventsList(
      timeMin: string,
      timeMax?: string | null,
      userIds?: Array<number>,
    ): CancelablePromise<Array<WorkboardTaskCalendarEventsQuery>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard-tasks/calendar/events',
        query: {
          'time_min': timeMin,
          'time_max': timeMax,
          'user_ids': userIds,
        },
      });
    }
    /**
     * @param id
     * @returns WorkboardTask
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksRead(
      id: string,
    ): CancelablePromise<WorkboardTask> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard-tasks/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns WorkboardTask
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksUpdate(
      id: string,
      data: WorkboardTask,
    ): CancelablePromise<WorkboardTask> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/workboard-tasks/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns WorkboardTask
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksPartialUpdate(
      id: string,
      data: WorkboardTask,
    ): CancelablePromise<WorkboardTask> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/workboard-tasks/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/workboard-tasks/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param occurrenceDate Scheduled calendar date for this recurring task instance.
     * @returns WorkboardTaskOccurrence
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksOccurrencesRead(
      id: string,
      occurrenceDate: string,
    ): CancelablePromise<WorkboardTaskOccurrence> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard-tasks/{id}/occurrences/',
        path: {
          'id': id,
        },
        query: {
          'occurrence_date': occurrenceDate,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns WorkboardTaskOccurrence
     * @throws ApiError
     */
    public static apiDashboardWorkboardTasksOccurrencesPartialUpdate(
      id: string,
      data: WorkboardTaskOccurrence,
    ): CancelablePromise<WorkboardTaskOccurrence> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/workboard-tasks/{id}/occurrences/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param viewType
     * @returns TableViewListResponse
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsList(
      viewType: 'models' | 'valuations',
    ): CancelablePromise<TableViewListResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard/table-views/',
        query: {
          'view_type': viewType,
        },
      });
    }
    /**
     * @param data
     * @param viewType
     * @returns TableView
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsCreate(
      data: TableView,
      viewType: 'models' | 'valuations',
    ): CancelablePromise<TableView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dashboard/workboard/table-views/',
        query: {
          'view_type': viewType,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns TableView
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsRead(
      id: string,
    ): CancelablePromise<TableView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/workboard/table-views/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns TableView
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsUpdate(
      id: string,
      data: TableView,
    ): CancelablePromise<TableView> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/workboard/table-views/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns TableView
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsPartialUpdate(
      id: string,
      data: TableView,
    ): CancelablePromise<TableView> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/workboard/table-views/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiDashboardWorkboardTableViewsDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/dashboard/workboard/table-views/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param cmdId
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardRead(
      cmdId: string,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardUpdate(
      cmdId: string,
      data: ValuationOpinionModule,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @param data
     * @returns ValuationOpinionModule
     * @throws ApiError
     */
    public static apiDashboardPartialUpdate(
      cmdId: string,
      data: ValuationOpinionModule,
    ): CancelablePromise<ValuationOpinionModule> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/dashboard/{cmd_id}',
        path: {
          'cmd_id': cmdId,
        },
        body: data,
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGpcCompSetRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/{cmd_id}/gpc-comp-set',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param cmdId
     * @returns any
     * @throws ApiError
     */
    public static apiDashboardGpcCompsRead(
      cmdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dashboard/{cmd_id}/gpc-comps',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * Manually trigger document classification for a file
     * @param data
     * @returns AIClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationClassifyCreate(
      data: ClassifyDocument,
    ): CancelablePromise<AIClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/classify/',
        body: data,
        errors: {
          400: `Classification failed`,
          404: `File not found`,
        },
      });
    }
    /**
     * List all AI classifications for a specific file.
     * GET /api/documents/classification/file/<file_id>/
     * @param fileId
     * @returns AIClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationFileRead(
      fileId: string,
    ): CancelablePromise<Array<AIClassification>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/classification/file/{file_id}/',
        path: {
          'file_id': fileId,
        },
      });
    }
    /**
     * List all document references pending auto-classification approval.
     * GET /api/documents/classification/pending/
     * GET /api/documents/classification/pending/?md_id=<measurement_date_id>
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationPendingList(): CancelablePromise<Array<DocumentReferenceClassification>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/classification/pending/',
      });
    }
    /**
     * Approve a document's auto-classification suggestion
     * @param documentReferenceId
     * @param data
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationApproveCreate(
      documentReferenceId: string,
      data: ClassificationApproval,
    ): CancelablePromise<DocumentReferenceClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/{document_reference_id}/approve/',
        path: {
          'document_reference_id': documentReferenceId,
        },
        body: data,
        errors: {
          400: `Document not pending classification approval`,
          404: `Document reference not found`,
        },
      });
    }
    /**
     * Decline a document's auto-classification suggestion
     * @param documentReferenceId
     * @param data
     * @returns DocumentReferenceClassification
     * @throws ApiError
     */
    public static apiDocumentsClassificationDeclineCreate(
      documentReferenceId: string,
      data: ClassificationApproval,
    ): CancelablePromise<DocumentReferenceClassification> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/classification/{document_reference_id}/decline/',
        path: {
          'document_reference_id': documentReferenceId,
        },
        body: data,
        errors: {
          400: `Document not pending classification approval`,
          404: `Document reference not found`,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this measurement date documents.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsCompanyRead(
      id: number,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompanyDocuments>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/company/{id}',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param mdId
     * @param data
     * @returns DocumentReferenceObjectView
     * @throws ApiError
     */
    public static apiDocumentsDocumentReferenceObjectsCreate(
      mdId: string,
      data: CreateOrDeleteDocumentReferenceObject,
    ): CancelablePromise<Array<DocumentReferenceObjectView>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/document-reference-objects/{md_id}',
        path: {
          'md_id': mdId,
        },
        body: data,
      });
    }
    /**
     * Download actual file content from S3 instead of returning a signed URL.
     * Supports both direct file download and base64-encoded response.
     * @param fileId
     * @param versionId
     * @param base64
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsDownloadContentRead(
      fileId: string,
      versionId?: string,
      base64: boolean = false,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/download-content/{file_id}',
        path: {
          'file_id': fileId,
        },
        query: {
          'version_id': versionId,
          'base64': base64,
        },
      });
    }
    /**
     * @param fileId
     * @param versionId Optional version ID of the file to download a specific version (not used since we are not retaining versions ids yet)
     * @param firmId Optional firm ID to specify the firm context for the file download. Used when downloading a firm summary report.
     * @returns any Presigned URL to download the file.
     * @throws ApiError
     */
    public static apiDocumentsDownloadRead(
      fileId: string,
      versionId?: string,
      firmId?: string,
    ): CancelablePromise<{
      signed_url?: string;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/download/{file_id}',
        path: {
          'file_id': fileId,
        },
        query: {
          'version_id': versionId,
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFeatureObjectsRead(
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/feature-objects/{md_id}',
        path: {
          'md_id': mdId,
        },
      });
    }
    /**
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFileUploadRequestRead(
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/file-upload-request/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param mdPk
     * @param fileUuid
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFileUploadRequestRead1(
      mdPk: string,
      fileUuid: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/file-upload-request/{md_pk}/{file_uuid}',
        path: {
          'md_pk': mdPk,
          'file_uuid': fileUuid,
        },
      });
    }
    /**
     * @param firmId
     * @param search
     * @param fundId
     * @param ordering
     * @returns FirmDocumentCompaniesResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsCompaniesList(
      firmId: string,
      search?: string,
      fundId?: number,
      ordering: 'name' | '-name' | 'document_count' | '-document_count' = 'name',
    ): CancelablePromise<FirmDocumentCompaniesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/companies',
        path: {
          'firm_id': firmId,
        },
        query: {
          'search': search,
          'fund_id': fundId,
          'ordering': ordering,
        },
      });
    }
    /**
     * @param firmId
     * @param data
     * @returns FirmDocumentReferenceBulkDeleteResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentReferencesBulkDeleteCreate(
      firmId: string,
      data: FirmDocumentReferenceBulkDeleteRequest,
    ): CancelablePromise<FirmDocumentReferenceBulkDeleteResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/firms/{firm_id}/document-references/bulk-delete',
        path: {
          'firm_id': firmId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param data
     * @returns FirmDocumentReferenceTransferResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentReferencesTransferCreate(
      firmId: string,
      data: FirmDocumentReferenceTransferRequest,
    ): CancelablePromise<FirmDocumentReferenceTransferResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/firms/{firm_id}/document-references/transfer',
        path: {
          'firm_id': firmId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param documentReferenceId
     * @param data
     * @returns FirmDocumentReference
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentReferencesPartialUpdate(
      firmId: string,
      documentReferenceId: string,
      data: FirmDocumentReferenceUpdateRequest,
    ): CancelablePromise<FirmDocumentReference> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/firms/{firm_id}/document-references/{document_reference_id}',
        path: {
          'firm_id': firmId,
          'document_reference_id': documentReferenceId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param search
     * @param companyId
     * @param measurementDateId
     * @param measurementDate Visible measurement date in YYYY-MM-DD format for firm-level grouped Documents.
     * @param fundId
     * @param uploadedBy
     * @param fileType
     * @param source
     * @param referenceObjectType
     * @param ordering
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentsList(
      firmId: string,
      page?: number,
      pageSize?: number,
      search?: string,
      companyId?: number,
      measurementDateId?: number,
      measurementDate?: string,
      fundId?: number,
      uploadedBy?: number,
      fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
      source?: 'document_request' | 'generation_job' | 'user',
      referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
      ordering: '-uploaded_date' | 'uploaded_date' | 'filename' | '-filename' | 'company_name' | '-company_name' | 'measurement_date' | '-measurement_date' = '-uploaded_date',
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FirmDocumentReference>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/documents',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'page_size': pageSize,
          'search': search,
          'company_id': companyId,
          'measurement_date_id': measurementDateId,
          'measurement_date': measurementDate,
          'fund_id': fundId,
          'uploaded_by': uploadedBy,
          'file_type': fileType,
          'source': source,
          'reference_object_type': referenceObjectType,
          'ordering': ordering,
        },
      });
    }
    /**
     * @param firmId
     * @param search
     * @param companyId
     * @param measurementDateId
     * @param measurementDate Visible measurement date in YYYY-MM-DD format for firm-level grouped Documents.
     * @param fundId
     * @returns FirmDocumentFilterOptionsResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentsFilterOptionsList(
      firmId: string,
      search?: string,
      companyId?: number,
      measurementDateId?: number,
      measurementDate?: string,
      fundId?: number,
    ): CancelablePromise<FirmDocumentFilterOptionsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/documents/filter-options',
        path: {
          'firm_id': firmId,
        },
        query: {
          'search': search,
          'company_id': companyId,
          'measurement_date_id': measurementDateId,
          'measurement_date': measurementDate,
          'fund_id': fundId,
        },
      });
    }
    /**
     * @param firmId
     * @param search
     * @param companyId
     * @param preferredMeasurementDate Visible date to prioritize in suggestions without filtering out other dates.
     * @param fundId
     * @param uploadedBy
     * @param fileType
     * @param source
     * @param referenceObjectType
     * @param limit
     * @returns FirmDocumentSuggestionsResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsDocumentsSuggestionsList(
      firmId: string,
      search: string,
      companyId?: number,
      preferredMeasurementDate?: string,
      fundId?: number,
      uploadedBy?: number,
      fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
      source?: 'document_request' | 'generation_job' | 'user',
      referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
      limit: number = 8,
    ): CancelablePromise<FirmDocumentSuggestionsResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/documents/suggestions',
        path: {
          'firm_id': firmId,
        },
        query: {
          'search': search,
          'company_id': companyId,
          'preferred_measurement_date': preferredMeasurementDate,
          'fund_id': fundId,
          'uploaded_by': uploadedBy,
          'file_type': fileType,
          'source': source,
          'reference_object_type': referenceObjectType,
          'limit': limit,
        },
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param pageSize Number of results to return per page.
     * @param companyId Optional company ID for company-scoped measurement dates.
     * @param search
     * @param uploadedBy
     * @param fileType
     * @param source
     * @param referenceObjectType
     * @param targetDate Measurement date to locate before pagination is applied.
     * @param targetMeasurementDateId Measurement date ID to locate before pagination is applied.
     * @returns FirmDocumentMeasurementDatesResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsMeasurementDatesList(
      firmId: string,
      page?: number,
      pageSize?: number,
      companyId?: number,
      search?: string,
      uploadedBy?: number,
      fileType?: 'csv' | 'doc' | 'docx' | 'docm' | 'gif' | 'jpeg' | 'jpg' | 'key' | 'md' | 'numbers' | 'pages' | 'pdf' | 'png' | 'ppt' | 'pptx' | 'ppsm' | 'pptm' | 'rtf' | 'txt' | 'xls' | 'xlsx' | 'xlsm' | 'xlsb' | 'zip',
      source?: 'document_request' | 'generation_job' | 'user',
      referenceObjectType?: 'ct' | 'fi' | 'fo' | 'cb' | 'ev' | 'ssv' | 'fio' | 'ma' | 'rs',
      targetDate?: string,
      targetMeasurementDateId?: number,
    ): CancelablePromise<FirmDocumentMeasurementDatesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/measurement-dates',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'page_size': pageSize,
          'company_id': companyId,
          'search': search,
          'uploaded_by': uploadedBy,
          'file_type': fileType,
          'source': source,
          'reference_object_type': referenceObjectType,
          'target_date': targetDate,
          'target_measurement_date_id': targetMeasurementDateId,
        },
      });
    }
    /**
     * @param firmId
     * @param measurementDateId
     * @param companyId Optional company ID to validate the measurement date belongs to a selected company.
     * @returns FirmDocumentFoldersResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsMeasurementDatesFoldersList(
      firmId: string,
      measurementDateId: string,
      companyId?: number,
    ): CancelablePromise<FirmDocumentFoldersResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/measurement-dates/{measurement_date_id}/folders',
        path: {
          'firm_id': firmId,
          'measurement_date_id': measurementDateId,
        },
        query: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @param measurementDateId
     * @returns FirmDocumentRequestedFilesResponse
     * @throws ApiError
     */
    public static apiDocumentsFirmsRequestedFilesList(
      firmId: string,
      companyId: number,
      measurementDateId: number,
    ): CancelablePromise<FirmDocumentRequestedFilesResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/firms/{firm_id}/requested-files',
        path: {
          'firm_id': firmId,
        },
        query: {
          'company_id': companyId,
          'measurement_date_id': measurementDateId,
        },
      });
    }
    /**
     * @param mdPk
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsHasDocumentsRead(
      mdPk: string,
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/has-documents/{md_pk}/{company_id}',
        path: {
          'md_pk': mdPk,
          'company_id': companyId,
        },
      });
    }
    /**
     * Create a documents_file record with a DocumentReference in the Exports folder
     * after the client has uploaded a PDF export directly to S3 via a signed URL.
     * @param data
     * @returns FileModel
     * @throws ApiError
     */
    public static apiDocumentsPdfExportConfirmUploadCreate(
      data: ConfirmPdfExportUpload,
    ): CancelablePromise<FileModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/pdf-export/confirm-upload',
        body: data,
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @param data
     * @returns DocumentReferencesView
     * @throws ApiError
     */
    public static apiDocumentsReferenceCreate(
      mdId: string,
      filePk: string,
      data: DocumentReferenceCreateRequest,
    ): CancelablePromise<DocumentReferencesView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/reference/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
        body: data,
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns DocumentReferenceDeleteResponse
     * @throws ApiError
     */
    public static apiDocumentsReferenceDelete(
      mdId: string,
      filePk: string,
    ): CancelablePromise<DocumentReferenceDeleteResponse> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/reference/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferenceObjectCreate(
      mdId: string,
      filePk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/reference_object/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param mdId
     * @param filePk
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsReferenceObjectDelete(
      mdId: string,
      filePk: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/reference_object/{md_id}/{file_pk}',
        path: {
          'md_id': mdId,
          'file_pk': filePk,
        },
      });
    }
    /**
     * @param documentReferenceId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferencesRead(
      documentReferenceId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/references/{document_reference_id}',
        path: {
          'document_reference_id': documentReferenceId,
        },
      });
    }
    /**
     * GET /api/documents/<document_reference_id>/parser-results/
     * Returns a presigned URL for the parser results JSON stored on the source PDF File.
     * The JSON contains per-page word positions used by the PDF citation layer.
     * @param documentReferenceId
     * @returns URL
     * @throws ApiError
     */
    public static apiDocumentsReferencesParserResultsRead(
      documentReferenceId: string,
    ): CancelablePromise<URL> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/references/{document_reference_id}/parser-results/',
        path: {
          'document_reference_id': documentReferenceId,
        },
      });
    }
    /**
     * @param data
     * @returns DocumentRequestView
     * @throws ApiError
     */
    public static apiDocumentsRequestCreate(
      data: DocumentRequestView,
    ): CancelablePromise<DocumentRequestView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/request',
        body: data,
      });
    }
    /**
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileCreate(
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requested-file',
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileUpdate(
      id: number,
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @param data
     * @returns IndividualRequestedFile
     * @throws ApiError
     */
    public static apiDocumentsRequestedFilePartialUpdate(
      id: number,
      data: IndividualRequestedFile,
    ): CancelablePromise<IndividualRequestedFile> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this requested file.
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsRequestedFileDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/requested-file/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * After each successful upload (to bucket) we hit this endpoint to create File and DocumentReference objects,
     * to update the RequestedFile status, and check if the entire task is done.
     * @param documentRequestId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsFileUploadStatusCreate(
      documentRequestId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/file-upload-status/{document_request_id}/{hmac_token}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * Return current delegation status for the document request.
     * @param taskId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskAppDelegateList(
      taskId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<AdminDelegateDocumentRequest>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/task/{task_id}/app-delegate',
        path: {
          'task_id': taskId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * Admin-level delegation endpoint.
     * @param taskId
     * @param data
     * @returns AdminDelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskAppDelegateCreate(
      taskId: string,
      data: AdminDelegateDocumentRequest,
    ): CancelablePromise<AdminDelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/task/{task_id}/app-delegate',
        path: {
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsValidateTokenRead(
      documentRequestId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/validate-token/{document_request_id}/{hmac_token}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * Allows a portal user to delegate their document request to another person.
     * No login required - uses HMAC token authentication.
     * @param documentRequestId
     * @param hmacToken
     * @param data
     * @returns DelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsDelegateCreate(
      documentRequestId: string,
      hmacToken: string,
      data: DelegateDocumentRequest,
    ): CancelablePromise<DelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/delegate',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
     * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
     * No login required - uses HMAC token authentication.
     * @param documentRequestId
     * @param hmacToken
     * @param data
     * @returns RedelegateDocumentRequest
     * @throws ApiError
     */
    public static apiDocumentsRequestsRedelegateCreate(
      documentRequestId: string,
      hmacToken: string,
      data: RedelegateDocumentRequest,
    ): CancelablePromise<RedelegateDocumentRequest> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/redelegate',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRequestsSignedUrlRead(
      documentRequestId: string,
      hmacToken: string,
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/signed-url/{md_pk}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param taskId
     * @param data
     * @returns TaskModel
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskStatusUpdate(
      documentRequestId: string,
      hmacToken: string,
      taskId: string,
      data: TaskModel,
    ): CancelablePromise<TaskModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param documentRequestId
     * @param hmacToken
     * @param taskId
     * @param data
     * @returns TaskModel
     * @throws ApiError
     */
    public static apiDocumentsRequestsTaskStatusPartialUpdate(
      documentRequestId: string,
      hmacToken: string,
      taskId: string,
      data: TaskModel,
    ): CancelablePromise<TaskModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/requests/{document_request_id}/{hmac_token}/task-status/{task_id}',
        path: {
          'document_request_id': documentRequestId,
          'hmac_token': hmacToken,
          'task_id': taskId,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this file.
     * @param data
     * @returns FileUpdateRequestedFiles
     * @throws ApiError
     */
    public static apiDocumentsUpdateRequestedFileUpdate(
      id: number,
      data: FileUpdateRequestedFiles,
    ): CancelablePromise<FileUpdateRequestedFiles> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/update-requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this file.
     * @param data
     * @returns FileUpdateRequestedFiles
     * @throws ApiError
     */
    public static apiDocumentsUpdateRequestedFilePartialUpdate(
      id: number,
      data: FileUpdateRequestedFiles,
    ): CancelablePromise<FileUpdateRequestedFiles> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/update-requested-file/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param data
     * @returns DocumentReferencesView
     * @throws ApiError
     */
    public static apiDocumentsAddToFolderCreate(
      docsId: string,
      data: AddDocumentReferencesToFolderRequest,
    ): CancelablePromise<Array<DocumentReferencesView>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/add-to-folder',
        path: {
          'docs_id': docsId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param data
     * @returns FileCreateResponse
     * @throws ApiError
     */
    public static apiDocumentsFilesCreate(
      docsId: string,
      data: FileCreateRequest,
    ): CancelablePromise<FileCreateResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/files',
        path: {
          'docs_id': docsId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesRead(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @param data
     * @returns FileView
     * @throws ApiError
     */
    public static apiDocumentsFilesUpdate(
      docsId: string,
      fileId: string,
      data: FileUpdate,
    ): CancelablePromise<FileView> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesPartialUpdate(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns DetailResponse
     * @throws ApiError
     */
    public static apiDocumentsFilesDelete(
      docsId: string,
      fileId: string,
    ): CancelablePromise<DetailResponse> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/{docs_id}/files/{file_id}',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @param fileId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFilesVersionsRead(
      docsId: string,
      fileId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/files/{file_id}/versions',
        path: {
          'docs_id': docsId,
          'file_id': fileId,
        },
      });
    }
    /**
     * @param docsId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsFolderCreate(
      docsId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/documents/{docs_id}/folder',
        path: {
          'docs_id': docsId,
        },
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @returns FolderView
     * @throws ApiError
     */
    public static apiDocumentsFolderRead(
      docsId: string,
      folderId: string,
    ): CancelablePromise<FolderView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @param data
     * @returns FolderModel
     * @throws ApiError
     */
    public static apiDocumentsFolderUpdate(
      docsId: string,
      folderId: string,
      data: FolderModel,
    ): CancelablePromise<FolderModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @param data
     * @returns FolderView
     * @throws ApiError
     */
    public static apiDocumentsFolderPartialUpdate(
      docsId: string,
      folderId: string,
      data: FolderView,
    ): CancelablePromise<FolderView> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
        body: data,
      });
    }
    /**
     * @param docsId
     * @param folderId
     * @returns void
     * @throws ApiError
     */
    public static apiDocumentsFolderDelete(
      docsId: string,
      folderId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/documents/{docs_id}/folder/{folder_id}',
        path: {
          'docs_id': docsId,
          'folder_id': folderId,
        },
      });
    }
    /**
     * @param mdId
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsReferencesRead1(
      mdId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{md_id}/references',
        path: {
          'md_id': mdId,
        },
      });
    }
    /**
     * @param mdPk
     * @returns any
     * @throws ApiError
     */
    public static apiDocumentsRead(
      mdPk: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/documents/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param redirectUri OAuth redirect URI
     * @param state Opaque CSRF state token
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxOauth2AuthorizeUrlList(
      redirectUri: string,
      state?: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dropbox/oauth2/authorize-url',
        query: {
          'redirect_uri': redirectUri,
          'state': state,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxOauth2DisconnectCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dropbox/oauth2/disconnect',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxOauth2StatusList(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dropbox/oauth2/status',
      });
    }
    /**
     * @param data
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxOauth2TokenCreate(
      data: {
        grant_type: string;
        code?: string;
        redirect_uri: string;
      },
    ): CancelablePromise<{
      grant_type: string;
      code?: string;
      redirect_uri: string;
    }> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dropbox/oauth2/token',
        body: data,
      });
    }
    /**
     * Staff-only proxy that forwards requests to the Dropbox HTTP API (RPC base URL).
     * GET is translated to a Dropbox RPC POST with a JSON body derived from query params.
     * POST sends JSON bodies to Dropbox.
     * @param endpoint
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxRead(
      endpoint: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/dropbox/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
      });
    }
    /**
     * Staff-only proxy that forwards requests to the Dropbox HTTP API (RPC base URL).
     * GET is translated to a Dropbox RPC POST with a JSON body derived from query params.
     * POST sends JSON bodies to Dropbox.
     * @param endpoint
     * @param data
     * @returns any
     * @throws ApiError
     */
    public static apiDropboxCreate(
      endpoint: string,
      data: any,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/dropbox/{endpoint}',
        path: {
          'endpoint': endpoint,
        },
        body: data,
      });
    }
    /**
     * Retrieve full company reports information for a specific date and firm independently of their status.
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param date The date (YYYY-MM-DD) for which to retrieve or generate full company reports.
     * @returns ExcelExportGet
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsByDateList(
      firmId: string,
      page?: number,
      date?: string,
    ): CancelablePromise<Array<ExcelExportGet>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports-by-date',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'date': date,
        },
      });
    }
    /**
     * Enqueue full company reports generation for the specified company measurement dates.
     * Request body indicates which reports could be enqueued based on the flags for statuses.
     * @param firmId
     * @param data
     * @param date The date (YYYY-MM-DD) for which to retrieve or generate full company reports.
     * @returns ExcelExportStartInputData
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsByDateCreate(
      firmId: string,
      data: ExcelExportStartInputData,
      date?: string,
    ): CancelablePromise<ExcelExportStartInputData> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/excel-exports/{firm_id}/full-company-reports-by-date',
        path: {
          'firm_id': firmId,
        },
        query: {
          'date': date,
        },
        body: data,
      });
    }
    /**
     * Retrieve all full company reports for a firm, regardless of their status.
     * @param firmId
     * @param date
     * @returns AutoUpdatedFirmReportZipModel
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsAllReportsRead(
      firmId: string,
      date: string,
    ): CancelablePromise<AutoUpdatedFirmReportZipModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/all-reports/{date}',
        path: {
          'firm_id': firmId,
          'date': date,
        },
        errors: {
          404: `No reports found for the specified date.`,
        },
      });
    }
    /**
     * Generates a signed url for the auto updated firm zip to return it to client app
     * @param firmId
     * @param date
     * @returns any The signed url for the firm zip
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsAllReportsSignedUrlRead(
      firmId: string,
      date: string,
    ): CancelablePromise<{
      /**
       * The signed url
       */
      signed_url?: string;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/all-reports/{date}/signed_url',
        path: {
          'firm_id': firmId,
          'date': date,
        },
      });
    }
    /**
     * Retrieve or generate full company reports for the specified company measurement dates in a single zip file.
     * @param firmId
     * @param data
     * @returns any A job ID indicating that all reports are ready for download.
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsDownloadJobCreate(
      firmId: string,
      data: ExcelExportsRequested,
    ): CancelablePromise<{
      /**
       * A unique job identifier.
       */
      job_id?: string;
    }> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/excel-exports/{firm_id}/full-company-reports/download-job',
        path: {
          'firm_id': firmId,
        },
        body: data,
        errors: {
          409: `Indicates that some reports need to be generated.`,
        },
      });
    }
    /**
     * Check the status of download job
     * @param firmId
     * @param jobId
     * @returns JobStatusResponse Zip is available
     * @throws ApiError
     */
    public static apiExcelExportsFullCompanyReportsDownloadJobRead(
      firmId: string,
      jobId: string,
    ): CancelablePromise<JobStatusResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/excel-exports/{firm_id}/full-company-reports/download-job/{job_id}',
        path: {
          'firm_id': firmId,
          'job_id': jobId,
        },
        errors: {
          404: `Job not found.`,
        },
      });
    }
    /**
     * @param fileId
     * @param inspect When true, process the XLSX if needed and return a signed URL. When false or omitted, only poll for existing processed output.
     * @returns PresignedURL
     * @throws ApiError
     */
    public static apiFilesProcessedRead(
      fileId: string,
      inspect: boolean = false,
    ): CancelablePromise<PresignedURL> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/files/{file_id}/processed',
        path: {
          'file_id': fileId,
        },
        query: {
          'inspect': inspect,
        },
      });
    }
    /**
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate(
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/',
        body: data,
      });
    }
    /**
     * @param cmdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialRfydRead(
      cmdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{cmd_pk}/financial_rfyd/',
        path: {
          'cmd_pk': cmdPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageRead(
      id: number,
    ): CancelablePromise<FinancialStatementFullRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreate1(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageUpdate(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPagePartialUpdate(
      id: number,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @returns void
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/financials/financial_page/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this financial statement.
     * @param data
     * @returns FinancialStatementFullRead
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageCreateVersionCreate(
      id: number,
      data: FinancialStatementVersionValidator,
    ): CancelablePromise<FinancialStatementFullRead> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/financial_page/{id}/create_version/',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialLtmNtmRead(
      mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/financial_ltm_ntm/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * This view is used outside of the Financials page (Valuation and Waterfall pages, so there's no value for the mapping references there).
     * Let's keep separate serializers for this so we don't include data we don't need and avoid unnecessary queries
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns FinancialStatementBasicData
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageFinancialsBasicDataListList(
      mdPk: string,
      page?: number,
    ): CancelablePromise<Array<FinancialStatementBasicData>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/financials_basic_data_list/',
        path: {
          'md_pk': mdPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param mdPk
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateRead(
      mdPk: string,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDateUpdate(
      mdPk: string,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @param data
     * @returns FinancialStatementFullWrite
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageGetByMeasurementDatePartialUpdate(
      mdPk: string,
      data: FinancialStatementFullWrite,
    ): CancelablePromise<FinancialStatementFullWrite> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/financials/financial_page/{md_pk}/get_by_measurement_date/',
        path: {
          'md_pk': mdPk,
        },
        body: data,
      });
    }
    /**
     * @param mdPk
     * @param page A page number within the paginated result set.
     * @returns FinancialStatementSmall
     * @throws ApiError
     */
    public static apiFinancialsFinancialPageListByMeasurementPeriodList(
      mdPk: string,
      page?: number,
    ): CancelablePromise<Array<FinancialStatementSmall>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/financials/financial_page/{md_pk}/list_by_measurement_period/',
        path: {
          'md_pk': mdPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiFinancialsImportExtractedCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/financials/import-extracted',
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FirmUserPermission>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns FirmCompany
     * @throws ApiError
     */
    public static apiFirmsCompaniesNewCreate(
      data: FirmCompany,
    ): CancelablePromise<FirmCompany> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/companies/new',
        body: data,
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCreateFirmQuestionCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-firm-question',
      });
    }
    /**
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsCreateFirmRequestedDocumentCreate(
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-firm-requested-document',
        body: data,
      });
    }
    /**
     * @param data
     * @returns CreateFirmRequests
     * @throws ApiError
     */
    public static apiFirmsCreateRequestsCreate(
      data: CreateFirmRequests,
    ): CancelablePromise<CreateFirmRequests> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/create-requests',
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentRead(
      requestedDocumentId: string,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentUpdate(
      requestedDocumentId: string,
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @param data
     * @returns FirmRequestedDocumentModel
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentPartialUpdate(
      requestedDocumentId: string,
      data: FirmRequestedDocumentModel,
    ): CancelablePromise<FirmRequestedDocumentModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
        body: data,
      });
    }
    /**
     * @param requestedDocumentId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsFirmRequestedDocumentDelete(
      requestedDocumentId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/firm-requested-document/{requested_document_id}',
        path: {
          'requested_document_id': requestedDocumentId,
        },
      });
    }
    /**
     * @param data
     * @returns FirmStepper
     * @throws ApiError
     */
    public static apiFirmsNewCreate(
      data: FirmStepper,
    ): CancelablePromise<FirmStepper> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/new',
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionRead(
      questionId: string,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionUpdate(
      questionId: string,
      data: UpdateFirmQuestion,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @param data
     * @returns UpdateFirmQuestion
     * @throws ApiError
     */
    public static apiFirmsQuestionPartialUpdate(
      questionId: string,
      data: UpdateFirmQuestion,
    ): CancelablePromise<UpdateFirmQuestion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
        body: data,
      });
    }
    /**
     * @param questionId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsQuestionDelete(
      questionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/question/{question_id}',
        path: {
          'question_id': questionId,
        },
      });
    }
    /**
     * @param firmId
     * @param fileType
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsAssetSignedUrlRead(
      firmId: string,
      fileType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/asset-signed-url/{file_type}',
        path: {
          'firm_id': firmId,
          'file_type': fileType,
        },
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param date
     * @returns DailyNavRecord
     * @throws ApiError
     */
    public static apiFirmsDailyNavList(
      firmId: string,
      page?: number,
      date?: string,
    ): CancelablePromise<Array<DailyNavRecord>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'date': date,
        },
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns CompanyDailyNavConfigCurrent
     * @throws ApiError
     */
    public static apiFirmsDailyNavCompaniesConfigList(
      firmId: string,
      companyId: string,
      page?: number,
    ): CancelablePromise<CompanyDailyNavConfigCurrent> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/',
        path: {
          'firm_id': firmId,
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @param data
     * @returns CompanyDailyNavConfigVersion
     * @throws ApiError
     */
    public static apiFirmsDailyNavCompaniesConfigUpdate(
      firmId: string,
      companyId: string,
      data: CompanyDailyNavConfigUpdate,
    ): CancelablePromise<CompanyDailyNavConfigVersion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/',
        path: {
          'firm_id': firmId,
          'company_id': companyId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsDailyNavCompaniesConfigHistoryList(
      firmId: string,
      companyId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompanyDailyNavConfigVersion>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/companies/{company_id}/config/history/',
        path: {
          'firm_id': firmId,
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @returns FirmDailyNavConfigVersion
     * @throws ApiError
     */
    public static apiFirmsDailyNavConfigList(
      firmId: string,
      page?: number,
    ): CancelablePromise<FirmDailyNavConfigVersion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/config/',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @param data
     * @returns FirmDailyNavConfigVersion
     * @throws ApiError
     */
    public static apiFirmsDailyNavConfigUpdate(
      firmId: string,
      data: FirmDailyNavConfigUpdate,
    ): CancelablePromise<FirmDailyNavConfigVersion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_id}/daily-nav/config/',
        path: {
          'firm_id': firmId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsDailyNavConfigHistoryList(
      firmId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FirmDailyNavConfigVersion>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/config/history/',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @param date
     * @returns DailyNavRecordGenerateResponse
     * @throws ApiError
     */
    public static apiFirmsDailyNavGenerateCreate(
      firmId: string,
      date?: string,
    ): CancelablePromise<DailyNavRecordGenerateResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{firm_id}/daily-nav/generate/',
        path: {
          'firm_id': firmId,
        },
        query: {
          'date': date,
        },
      });
    }
    /**
     * The "previous valuation" the Daily NAV grid shows per company: the latest FINAL
     * company-rollup Looking Glass snapshot strictly before the report date. Returns
     * one row per company (reusing the Looking Glass summary-data shape), so the client
     * no longer loads the full snapshot history just to dedupe it to one row each.
     * @param firmId
     * @param page A page number within the paginated result set.
     * @param date Report date; the previous valuation is the latest FINAL company rollup strictly before this date. Defaults to the effective NAV date.
     * @param fields Optional comma-separated summary field keys to return on each row, e.g. equity_value,common_share_value. Omit for the default field set.
     * @returns LookingGlassSummaryData
     * @throws ApiError
     */
    public static apiFirmsDailyNavPreviousValuationsList(
      firmId: string,
      page?: number,
      date?: string,
      fields?: string,
    ): CancelablePromise<Array<LookingGlassSummaryData>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/daily-nav/previous-valuations/',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
          'date': date,
          'fields': fields,
        },
      });
    }
    /**
     * @param firmId
     * @param companyId
     * @returns InvestmentCompanyInfo
     * @throws ApiError
     */
    public static apiFirmsFundInvestmentRead(
      firmId: string,
      companyId: string,
    ): CancelablePromise<InvestmentCompanyInfo> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/fund-investment/{company_id}',
        path: {
          'firm_id': firmId,
          'company_id': companyId,
        },
      });
    }
    /**
     * @param firmId
     * @returns FirmRequestsView
     * @throws ApiError
     */
    public static apiFirmsQuestionsAndRequestedDocumentsRead(
      firmId: string,
    ): CancelablePromise<FirmRequestsView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/questions-and-requested-documents',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param firmId
     * @returns FirmCompaniesRequestsProgress
     * @throws ApiError
     */
    public static apiFirmsRequestsProgressRead(
      firmId: string,
    ): CancelablePromise<FirmCompaniesRequestsProgress> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_id}/requests-progress',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param firmPk
     * @param page A page number within the paginated result set.
     * @returns CompaniesByFirm A list of CompaniesByFirm objects
     * @throws ApiError
     */
    public static apiFirmsCompaniesListList(
      firmPk: string,
      page?: number,
    ): CancelablePromise<Array<CompaniesByFirm>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{firm_pk}/companies-list/',
        path: {
          'firm_pk': firmPk,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersUpdate(
      firmPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users',
        path: {
          'firm_pk': firmPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersPartialUpdate(
      firmPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users',
        path: {
          'firm_pk': firmPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersUpdate1(
      firmPk: string,
      userPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUsersPartialUpdate1(
      firmPk: string,
      userPk: string,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsUsersDelete(
      firmPk: string,
      userPk: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/{firm_pk}/users/{user_pk}',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns UserFirmRole
     * @throws ApiError
     */
    public static apiFirmsUsersRolesUpdate(
      firmPk: string,
      userPk: string,
      data: UserFirmRole,
    ): CancelablePromise<UserFirmRole> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param firmPk
     * @param userPk
     * @param data
     * @returns UserFirmRole
     * @throws ApiError
     */
    public static apiFirmsUsersRolesPartialUpdate(
      firmPk: string,
      userPk: string,
      data: UserFirmRole,
    ): CancelablePromise<UserFirmRole> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{firm_pk}/users/{user_pk}/roles',
        path: {
          'firm_pk': firmPk,
          'user_pk': userPk,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsRead(
      id: number,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsUpdate(
      id: number,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this firm.
     * @param data
     * @returns Firm
     * @throws ApiError
     */
    public static apiFirmsPartialUpdate(
      id: number,
      data: Firm,
    ): CancelablePromise<Firm> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCompaniesList(
      id: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FirmCompanies>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/companies',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param cId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsCompanyRead(
      id: string,
      cId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ExtendedCompanyInfo>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/company/{c_id}',
        path: {
          'id': id,
          'c_id': cId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this fund.
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsFundsList(
      id: number,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<FundName>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/funds',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsGenerationJobsBulkCreate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/generation-jobs/bulk',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiFirmsHasSummaryRead(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/has-summary',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns any Indicates if the firm has summary data
     * @throws ApiError
     */
    public static apiFirmsHasSummaryCreate(
      id: string,
      data: FundByMeasurementDate,
    ): CancelablePromise<{
      has_summary?: boolean;
    }> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/has-summary',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format
     * @param fundId Optional fund ID filter
     * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
     * @returns Investment A list of Investments scoped to the firm
     * @throws ApiError
     */
    public static apiFirmsInvestmentsRead(
      id: string,
      date?: string,
      fundId?: number,
      breakevenMultiple?: string,
    ): CancelablePromise<Array<Investment>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/investments',
        path: {
          'id': id,
        },
        query: {
          'date': date,
          'fund_id': fundId,
          'breakeven_multiple': breakevenMultiple,
        },
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format
     * @param fundId Optional fund ID filter
     * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
     * @returns FirmSummaryRead
     * @throws ApiError
     */
    public static apiFirmsSummaryRead(
      id: string,
      date?: string,
      fundId?: number,
      breakevenMultiple?: string,
    ): CancelablePromise<FirmSummaryRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary',
        path: {
          'id': id,
        },
        query: {
          'date': date,
          'fund_id': fundId,
          'breakeven_multiple': breakevenMultiple,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns FirmDefinitionListResponse
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsList(
      id: string,
      page?: number,
    ): CancelablePromise<FirmDefinitionListResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary-definitions',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsCreate(
      id: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/summary-definitions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns AIAssistResponse
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsAiAssistCreate(
      id: string,
      data: AIAssistRequest,
    ): CancelablePromise<AIAssistResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/summary-definitions/ai-assist',
        path: {
          'id': id,
        },
        body: data,
        errors: {
          400: `Invalid request`,
          503: `AI service unavailable`,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate
     * @returns AvailableFund
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsFundsList(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<Array<AvailableFund>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary-definitions/funds',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsOrderUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}/summary-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsOrderPartialUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}/summary-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsRead(
      id: string,
      definitionId: string,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsUpdate(
      id: string,
      definitionId: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsPartialUpdate(
      id: string,
      definitionId: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsDelete(
      id: string,
      definitionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param fundId Optional fund ID to scope chart series to a single fund so the popover trend matches the fund-filtered table row.
     * @returns ChartDataResponse
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsChartDataRead(
      id: string,
      definitionId: string,
      fundId?: number | null,
    ): CancelablePromise<ChartDataResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary-definitions/{definition_id}/chart-data',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        query: {
          'fund_id': fundId,
        },
        errors: {
          400: `Invalid request`,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param measurementDate
     * @param fundId Optional fund ID to scope rows before applying definition filters and sort keys.
     * @returns SummaryDataResponse
     * @throws ApiError
     */
    public static apiFirmsSummaryDefinitionsDataRead(
      id: string,
      definitionId: string,
      measurementDate?: string,
      fundId?: number | null,
    ): CancelablePromise<SummaryDataResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/summary-definitions/{definition_id}/data',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        query: {
          'measurement_date': measurementDate,
          'fund_id': fundId,
        },
        errors: {
          400: `Invalid measurement date or filter type mismatch`,
        },
      });
    }
    /**
     * Firm valuations page data endpoint. Separate URL and definition namespace
     * from the intelligence page; same underlying data source for now.
     *
     * Override get() when a valuations-specific data service is needed.
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format
     * @param fundId Optional fund ID filter
     * @param breakevenMultiple Optional breakeven multiple (e.g., 1.0, 1.25, 2.0)
     * @returns FirmSummaryRead
     * @throws ApiError
     */
    public static apiFirmsValuationsRead(
      id: string,
      date?: string,
      fundId?: number,
      breakevenMultiple?: string,
    ): CancelablePromise<FirmSummaryRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations',
        path: {
          'id': id,
        },
        query: {
          'date': date,
          'fund_id': fundId,
          'breakeven_multiple': breakevenMultiple,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns FirmDefinitionListResponse
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsList(
      id: string,
      page?: number,
    ): CancelablePromise<FirmDefinitionListResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations-definitions',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsCreate(
      id: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/valuations-definitions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns AIAssistResponse
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsAiAssistCreate(
      id: string,
      data: AIAssistRequest,
    ): CancelablePromise<AIAssistResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/firms/{id}/valuations-definitions/ai-assist',
        path: {
          'id': id,
        },
        body: data,
        errors: {
          400: `Invalid request`,
          503: `AI service unavailable`,
        },
      });
    }
    /**
     * @param id
     * @param measurementDate
     * @returns AvailableFund
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsFundsList(
      id: string,
      measurementDate?: string,
    ): CancelablePromise<Array<AvailableFund>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations-definitions/funds',
        path: {
          'id': id,
        },
        query: {
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsOrderUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}/valuations-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsOrderPartialUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}/valuations-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsRead(
      id: string,
      definitionId: string,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsUpdate(
      id: string,
      definitionId: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FirmSummaryDefinition
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsPartialUpdate(
      id: string,
      definitionId: string,
      data: FirmSummaryDefinition,
    ): CancelablePromise<FirmSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns void
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsDelete(
      id: string,
      definitionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param fundId Optional fund ID to scope chart series to a single fund so the popover trend matches the fund-filtered table row.
     * @returns ChartDataResponse
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsChartDataRead(
      id: string,
      definitionId: string,
      fundId?: number | null,
    ): CancelablePromise<ChartDataResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}/chart-data',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        query: {
          'fund_id': fundId,
        },
        errors: {
          400: `Invalid request`,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param measurementDate
     * @param fundId Optional fund ID to scope rows before applying definition filters and sort keys.
     * @returns SummaryDataResponse
     * @throws ApiError
     */
    public static apiFirmsValuationsDefinitionsDataRead(
      id: string,
      definitionId: string,
      measurementDate?: string,
      fundId?: number | null,
    ): CancelablePromise<SummaryDataResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/firms/{id}/valuations-definitions/{definition_id}/data',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        query: {
          'measurement_date': measurementDate,
          'fund_id': fundId,
        },
        errors: {
          400: `Invalid measurement date or filter type mismatch`,
        },
      });
    }
    /**
     * @param allocationId
     * @returns any
     * @throws ApiError
     */
    public static apiFundInvestmentsRead(
      allocationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/fund-investments/{allocation_id}/',
        path: {
          'allocation_id': allocationId,
        },
      });
    }
    /**
     * @param allocationId
     * @returns any
     * @throws ApiError
     */
    public static apiFundInvestmentsCreate(
      allocationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/fund-investments/{allocation_id}/',
        path: {
          'allocation_id': allocationId,
        },
      });
    }
    /**
     * @param companyId
     * @param measurementDateId
     * @returns AvailableAllocation
     * @throws ApiError
     */
    public static apiFundInvestmentsExportDataAvailabilityRead(
      companyId: string,
      measurementDateId: string,
    ): CancelablePromise<Array<AvailableAllocation>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/fund-investments/{company_id}/export-data-availability/{measurement_date_id}/',
        path: {
          'company_id': companyId,
          'measurement_date_id': measurementDateId,
        },
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFundsList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<Fund>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsCreate(
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/funds',
        body: data,
      });
    }
    /**
     * PATCH `is_excluded_from_calculations` on a single CashDistribution row.
     * @param id A unique integer value identifying this cash distribution.
     * @param data
     * @returns CashDistributionExclusion
     * @throws ApiError
     */
    public static apiFundsCashDistributionExclusionPartialUpdate(
      id: number,
      data: CashDistributionExclusion,
    ): CancelablePromise<CashDistributionExclusion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/cash-distribution/{id}/exclusion',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * PATCH `is_excluded_from_calculations` on a single SharesAcquisition row.
     * @param id A unique integer value identifying this shares acquisition.
     * @param data
     * @returns SharesAcquisitionExclusion
     * @throws ApiError
     */
    public static apiFundsSharesAcquisitionExclusionPartialUpdate(
      id: number,
      data: SharesAcquisitionExclusion,
    ): CancelablePromise<SharesAcquisitionExclusion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/shares-acquisition/{id}/exclusion',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * PATCH `is_excluded_from_calculations` on a single SharesSale row.
     * @param id A unique integer value identifying this shares sale.
     * @param data
     * @returns SharesSaleExclusion
     * @throws ApiError
     */
    public static apiFundsSharesSaleExclusionPartialUpdate(
      id: number,
      data: SharesSaleExclusion,
    ): CancelablePromise<SharesSaleExclusion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/shares-sale/{id}/exclusion',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param fuId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiFundsCompaniesList(
      fuId: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{fu_id}/companies/',
        path: {
          'fu_id': fuId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsRead(
      id: string,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsUpdate(
      id: string,
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns Fund
     * @throws ApiError
     */
    public static apiFundsPartialUpdate(
      id: string,
      data: Fund,
    ): CancelablePromise<Fund> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiFundsDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/funds/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns AllocationConclusionModel A list of Fund Allocation Summaries
     * @throws ApiError
     */
    public static apiFundsAllocationsList(
      id: string,
      page?: number,
      date?: string,
    ): CancelablePromise<Array<AllocationConclusionModel>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/allocations',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'date': date,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns Investment A list of Investments
     * @throws ApiError
     */
    public static apiFundsInvestmentsRead(
      id: string,
      date?: string,
    ): CancelablePromise<Array<Investment>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/investments',
        path: {
          'id': id,
        },
        query: {
          'date': date,
        },
      });
    }
    /**
     * @param id
     * @param date Optional date filter in YYYY-MM-DD format (if not provided returns most recent data)
     * @returns FundSummary A Fund Summary
     * @throws ApiError
     */
    public static apiFundsSummaryRead(
      id: string,
      date?: string,
    ): CancelablePromise<FundSummary> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/summary',
        path: {
          'id': id,
        },
        query: {
          'date': date,
        },
        errors: {
          400: `Invalid date format`,
        },
      });
    }
    /**
     * @param id
     * @param page A page number within the paginated result set.
     * @returns FundDefinitionListResponse
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsList(
      id: string,
      page?: number,
    ): CancelablePromise<FundDefinitionListResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/summary-definitions',
        path: {
          'id': id,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns FundSummaryDefinition
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsCreate(
      id: string,
      data: FundSummaryDefinition,
    ): CancelablePromise<FundSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/funds/{id}/summary-definitions',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsOrderUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/funds/{id}/summary-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns SummaryDefinitionOrder
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsOrderPartialUpdate(
      id: string,
      data: SummaryDefinitionOrder,
    ): CancelablePromise<SummaryDefinitionOrder> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/{id}/summary-definitions/order',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns FundSummaryDefinition
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsRead(
      id: string,
      definitionId: string,
    ): CancelablePromise<FundSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/funds/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FundSummaryDefinition
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsUpdate(
      id: string,
      definitionId: string,
      data: FundSummaryDefinition,
    ): CancelablePromise<FundSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/funds/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @param data
     * @returns FundSummaryDefinition
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsPartialUpdate(
      id: string,
      definitionId: string,
      data: FundSummaryDefinition,
    ): CancelablePromise<FundSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/funds/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param definitionId
     * @returns void
     * @throws ApiError
     */
    public static apiFundsSummaryDefinitionsDelete(
      id: string,
      definitionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/funds/{id}/summary-definitions/{definition_id}',
        path: {
          'id': id,
          'definition_id': definitionId,
        },
      });
    }
    /**
     * Create a mapping from generation job results.
     * For FINANCIAL_MAPPING jobs with metadata, this will also associate the mapping
     * with the financial statement.
     * @param jobId
     * @returns SheetAttributeMapping Mapping created successfully
     * @throws ApiError
     */
    public static apiGenerationJobsAttributeMappingsCreate(
      jobId: string,
    ): CancelablePromise<SheetAttributeMapping> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/generation-jobs/{job_id}/attribute-mappings',
        path: {
          'job_id': jobId,
        },
        errors: {
          400: `Bad request - invalid input or job not found`,
          500: `Server error during transformation`,
        },
      });
    }
    /**
     * @param data
     * @returns UpdateIndividualQuestion
     * @throws ApiError
     */
    public static apiIndividualQuestionsCreate(
      data: UpdateIndividualQuestion,
    ): CancelablePromise<UpdateIndividualQuestion> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/individual-questions/',
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this individual question.
     * @param data
     * @returns UpdateIndividualQuestion
     * @throws ApiError
     */
    public static apiIndividualQuestionsUpdate(
      id: number,
      data: UpdateIndividualQuestion,
    ): CancelablePromise<UpdateIndividualQuestion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/individual-questions/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this individual question.
     * @param data
     * @returns UpdateIndividualQuestion
     * @throws ApiError
     */
    public static apiIndividualQuestionsPartialUpdate(
      id: number,
      data: UpdateIndividualQuestion,
    ): CancelablePromise<UpdateIndividualQuestion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/individual-questions/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this individual question.
     * @returns void
     * @throws ApiError
     */
    public static apiIndividualQuestionsDelete(
      id: number,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/individual-questions/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * Check if an excel report exists and retrieve its metadata.
     * @param reportUuid
     * @param data
     * @returns FileModel
     * @throws ApiError
     */
    public static apiInvestorAppCheckExcelReportCreate(
      reportUuid: string,
      data: {
        /**
         * ID of the firm related to the report. Optional.
         */
        firm?: number;
      },
    ): CancelablePromise<FileModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/investor-app/check-excel-report/{reportUUID}',
        path: {
          'reportUUID': reportUuid,
        },
        body: data,
        errors: {
          404: `Report not found.`,
        },
      });
    }
    /**
     * @param reportUuid
     * @returns any
     * @throws ApiError
     */
    public static apiInvestorAppExcelReportCreate(
      reportUuid: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/investor-app/excel-report/{reportUUID}',
        path: {
          'reportUUID': reportUuid,
        },
      });
    }
    /**
     * Returns dates that have LookingGlass snapshots for a firm.
     * @param id
     * @param rowType LookingGlass row type to retrieve available dates for
     * @param page A page number within the paginated result set.
     * @returns LookingGlassAvailableDate
     * @throws ApiError
     */
    public static apiLookingGlassFirmsAvailableDatesList(
      id: string,
      rowType: 'firm' | 'fund_rollup' | 'company' | 'company_rollup' | 'company_investment',
      page?: number,
    ): CancelablePromise<Array<LookingGlassAvailableDate>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/looking-glass/firms/{id}/available-dates',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'row_type': rowType,
        },
        errors: {
          400: `Invalid query parameters`,
        },
      });
    }
    /**
     * Returns all active LookingGlass snapshots for a firm on a given measurement date.
     * Optionally filtered by fund_id and/or company_id.
     * @param id
     * @param measurementDateId The measurement date ID to retrieve snapshots for
     * @param page A page number within the paginated result set.
     * @param fundId Optional fund ID filter
     * @param companyId Optional company ID filter
     * @returns LookingGlassSnapshot
     * @throws ApiError
     */
    public static apiLookingGlassFirmsSnapshotsList(
      id: string,
      measurementDateId: number,
      page?: number,
      fundId?: number,
      companyId?: number,
    ): CancelablePromise<Array<LookingGlassSnapshot>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/looking-glass/firms/{id}/snapshots',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'measurement_date_id': measurementDateId,
          'fund_id': fundId,
          'company_id': companyId,
        },
        errors: {
          400: `Invalid query parameters`,
        },
      });
    }
    /**
     * Returns field-based LookingGlass summary data for a firm.
     * @param id
     * @param rowType LookingGlass row type to retrieve
     * @param page A page number within the paginated result set.
     * @param measurementDateId Optional measurement date ID for exact snapshot lookup
     * @param startDate Start date for retrieving snapshots across a date range
     * @param endDate End date for retrieving snapshots across a date range
     * @param fields Optional comma-separated Firm Summary field keys to return on each row, e.g. gross_irr,enterprise_value. Omit to return the default Firm Summary field set.
     * @returns LookingGlassSummaryData Snapshot identity fields plus requested Firm Summary fields. If fields is omitted, returns the default Firm Summary field set.
     * @throws ApiError
     */
    public static apiLookingGlassFirmsSummaryDataList(
      id: string,
      rowType: 'firm' | 'fund_rollup' | 'company' | 'company_rollup' | 'company_investment',
      page?: number,
      measurementDateId?: number,
      startDate?: string,
      endDate?: string,
      fields?: string,
    ): CancelablePromise<Array<LookingGlassSummaryData>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/looking-glass/firms/{id}/summary-data',
        path: {
          'id': id,
        },
        query: {
          'page': page,
          'measurement_date_id': measurementDateId,
          'start_date': startDate,
          'end_date': endDate,
          'row_type': rowType,
          'fields': fields,
        },
        errors: {
          400: `Invalid query parameters`,
        },
      });
    }
    /**
     * Returns a single active LookingGlass snapshot by its primary key.
     * @param id
     * @returns LookingGlassSnapshot
     * @throws ApiError
     */
    public static apiLookingGlassSnapshotsRead(
      id: string,
    ): CancelablePromise<LookingGlassSnapshot> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/looking-glass/snapshots/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * This APIView is used to get all of the companymeasurement dates for a firm.
     * @param firmId
     * @returns CompanyMeasurementDateName
     * @throws ApiError
     */
    public static apiMeasurementDatesAllCompaniesByFirmRead(
      firmId: string,
    ): CancelablePromise<Array<CompanyMeasurementDateName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/all-companies-by-firm/{firm_id}/',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * This APIView is used to get all of the measurement dates for a firm.
     * @param firmId
     * @returns FundMeasurementDateName
     * @throws ApiError
     */
    public static apiMeasurementDatesAllFundsByFirmRead(
      firmId: string,
    ): CancelablePromise<Array<FundMeasurementDateName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/all-funds-by-firm/{firm_id}/',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * This APIView is used to get the measurement dates for a firm. It will return all the measurement dates
     * excluding the repeated ones, in other words the measurement dates with the same dates but for diferent
     * companies and funds, will be "merged" into one.
     * @param firmId
     * @returns MeasurementDateName
     * @throws ApiError
     */
    public static apiMeasurementDatesByFirmRead(
      firmId: string,
    ): CancelablePromise<Array<MeasurementDateName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/by-firm/{firm_id}',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param data
     * @returns MeasurementDateRolloverReturn Success
     * @throws ApiError
     */
    public static apiMeasurementDatesCompanyRolloverCreate(
      data: MeasurementDateRollover,
    ): CancelablePromise<MeasurementDateRolloverReturn> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/measurement-dates/company/rollover',
        body: data,
      });
    }
    /**
     * @param companyId
     * @returns MeasurementDateName
     * @throws ApiError
     */
    public static apiMeasurementDatesCompanyRead(
      companyId: string,
    ): CancelablePromise<Array<MeasurementDateName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/company/{company_id}',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * Concrete view for bulk delete Company/Fund measurement dates and all their related info.
     * @param data
     * @returns MeasurementDateExtended
     * @throws ApiError
     */
    public static apiMeasurementDatesDeleteRelatedInfoCreate(
      data: MeasurementDateExtended,
    ): CancelablePromise<MeasurementDateExtended> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/measurement-dates/delete-related-info',
        body: data,
      });
    }
    /**
     * @param firmId
     * @returns MeasurementDateName
     * @throws ApiError
     */
    public static apiMeasurementDatesFirmRead(
      firmId: string,
    ): CancelablePromise<Array<MeasurementDateName>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/firm/{firm_id}',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * This APIView is used to get the company/fund measurement dates from
     * measurement dates with the same date and firm, we merge the info into
     * one dictionary as a virtual "Measurement Date" and then we return it through
     * the serializer.
     * @param firmId
     * @param date
     * @returns any
     * @throws ApiError
     */
    public static apiMeasurementDatesFirmDateRead(
      firmId: string,
      date: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/firm/{firm_id}/date/{date}',
        path: {
          'firm_id': firmId,
          'date': date,
        },
      });
    }
    /**
     * @param fundId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiMeasurementDatesFundsRead(
      fundId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompanyMeasurementDateNameNullable>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/measurement-dates/funds/{fund_id}',
        path: {
          'fund_id': fundId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * Concrete view for bulk saving Note instances.
     * @param pageType
     * @param capTable
     * @param fundOwnership
     * @param financialStatement
     * @param fundMeasurementDate
     * @param allocation
     * @param valuationApproach
     * @param valuationApproachValuation
     * @param companyMeasurementDate
     * @param marketAdjustment
     * @param fundInvestmentOwnership
     * @param rangeSensitivity
     * @returns any
     * @throws ApiError
     */
    public static apiNotesList(
      pageType?: string,
      capTable?: string,
      fundOwnership?: string,
      financialStatement?: string,
      fundMeasurementDate?: string,
      allocation?: string,
      valuationApproach?: string,
      valuationApproachValuation?: string,
      companyMeasurementDate?: string,
      marketAdjustment?: string,
      fundInvestmentOwnership?: string,
      rangeSensitivity?: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notes/',
        query: {
          'page_type': pageType,
          'cap_table': capTable,
          'fund_ownership': fundOwnership,
          'financial_statement': financialStatement,
          'fund_measurement_date': fundMeasurementDate,
          'allocation': allocation,
          'valuation_approach': valuationApproach,
          'valuation_approach__valuation': valuationApproachValuation,
          'company_measurement_date': companyMeasurementDate,
          'market_adjustment': marketAdjustment,
          'fund_investment_ownership': fundInvestmentOwnership,
          'range_sensitivity': rangeSensitivity,
        },
      });
    }
    /**
     * Concrete view for bulk saving Note instances.
     * @param data
     * @returns Note
     * @throws ApiError
     */
    public static apiNotesCreate(
      data: Array<Note>,
    ): CancelablePromise<Array<Note>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/notes/',
        body: data,
      });
    }
    /**
     * Concrete view for bulk saving Note instances.
     * @param pageType
     * @param capTable
     * @param fundOwnership
     * @param financialStatement
     * @param fundMeasurementDate
     * @param allocation
     * @param valuationApproach
     * @param valuationApproachValuation
     * @param companyMeasurementDate
     * @param marketAdjustment
     * @param fundInvestmentOwnership
     * @param rangeSensitivity
     * @returns any
     * @throws ApiError
     */
    public static apiNotesListList(
      pageType?: string,
      capTable?: string,
      fundOwnership?: string,
      financialStatement?: string,
      fundMeasurementDate?: string,
      allocation?: string,
      valuationApproach?: string,
      valuationApproachValuation?: string,
      companyMeasurementDate?: string,
      marketAdjustment?: string,
      fundInvestmentOwnership?: string,
      rangeSensitivity?: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notes/list',
        query: {
          'page_type': pageType,
          'cap_table': capTable,
          'fund_ownership': fundOwnership,
          'financial_statement': financialStatement,
          'fund_measurement_date': fundMeasurementDate,
          'allocation': allocation,
          'valuation_approach': valuationApproach,
          'valuation_approach__valuation': valuationApproachValuation,
          'company_measurement_date': companyMeasurementDate,
          'market_adjustment': marketAdjustment,
          'fund_investment_ownership': fundInvestmentOwnership,
          'range_sensitivity': rangeSensitivity,
        },
      });
    }
    /**
     * Concrete view for bulk saving Note instances.
     * @param data
     * @returns Note
     * @throws ApiError
     */
    public static apiNotesListCreate(
      data: Array<Note>,
    ): CancelablePromise<Array<Note>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/notes/list',
        body: data,
      });
    }
    /**
     * Concrete view for retrieving Note instances.
     * @param id
     * @returns NoteGet
     * @throws ApiError
     */
    public static apiNotesRead(
      id: string,
    ): CancelablePromise<NoteGet> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notes/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiNotificationPreferencesList(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/notification-preferences',
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiNotificationPreferencesUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/notification-preferences/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param data
     * @returns SocialLoginResponse
     * @throws ApiError
     */
    public static apiOauth2SocialCreate(
      data: SocialLoginRequest,
    ): CancelablePromise<SocialLoginResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/oauth2/social/',
        body: data,
      });
    }
    /**
     * @param maturity
     * @param mdDate
     * @returns number A floating point value
     * @throws ApiError
     */
    public static apiObservationsRead(
      maturity: string,
      mdDate: string,
    ): CancelablePromise<number> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/observations/{maturity}/{md_date}',
        path: {
          'maturity': maturity,
          'md_date': mdDate,
        },
      });
    }
    /**
     * This endpoint is to see and resolve update decisions. So far the decision is to accept or reject updates from a change in a global comp group (set by Scalar app-wide).
     * Accepting the updates causes public comps or transaction comps approaches to be updated.
     * Rejecting the updates causes the update decision to be marked as resolved, but no changes are made to the approaches and the comp groups are no longer linked to the valuation approaches
     * @param firmId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiPendingDecisionsRead(
      firmId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<UpdateDecisionsView>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/pending-decisions/{firm_id}',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * This endpoint is to see and resolve update decisions. So far the decision is to accept or reject updates from a change in a global comp group (set by Scalar app-wide).
     * Accepting the updates causes public comps or transaction comps approaches to be updated.
     * Rejecting the updates causes the update decision to be marked as resolved, but no changes are made to the approaches and the comp groups are no longer linked to the valuation approaches
     * @param firmId
     * @param data
     * @returns UpdateDecisionsView
     * @throws ApiError
     */
    public static apiPendingDecisionsCreate(
      firmId: string,
      data: UpdateDecisionsView,
    ): CancelablePromise<UpdateDecisionsView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/pending-decisions/{firm_id}',
        path: {
          'firm_id': firmId,
        },
        body: data,
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiProfilesList(
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/profiles',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiProfilesCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/profiles',
      });
    }
    /**
     * @returns CustomUser
     * @throws ApiError
     */
    public static apiProfilesMe(): CancelablePromise<CustomUser> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/profiles/me',
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiProfilesRead(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiProfilesUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiProfilesPartialUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiProfilesDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/profiles/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @returns ChoiceAnswerModel
     * @throws ApiError
     */
    public static apiQuestionnairesChoicesForDropdownsList(): CancelablePromise<Array<ChoiceAnswerModel>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/questionnaires/choices-for-dropdowns/',
      });
    }
    /**
     * @param questionnaireId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiQuestionnairesRequestsValidateTokenRead(
      questionnaireId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/questionnaires/requests/validate-token/{questionnaire_id}/{hmac_token}',
        path: {
          'questionnaire_id': questionnaireId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * @param questionnaireId
     * @param hmacToken
     * @returns any
     * @throws ApiError
     */
    public static apiQuestionnairesRequestsValidateTokenAnswerQuestionCreate(
      questionnaireId: string,
      hmacToken: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/questionnaires/requests/validate-token/{questionnaire_id}/{hmac_token}/answer-question',
        path: {
          'questionnaire_id': questionnaireId,
          'hmac_token': hmacToken,
        },
      });
    }
    /**
     * Allows a portal user to delegate a questionnaire to another person.
     * No login required - uses HMAC token authentication.
     * @param questionnaireId
     * @param hmacToken
     * @param data
     * @returns DelegateQuestionnaire
     * @throws ApiError
     */
    public static apiQuestionnairesRequestsDelegateCreate(
      questionnaireId: string,
      hmacToken: string,
      data: DelegateQuestionnaire,
    ): CancelablePromise<DelegateQuestionnaire> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/questionnaires/requests/{questionnaire_id}/{hmac_token}/delegate',
        path: {
          'questionnaire_id': questionnaireId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * Allows a portal user to re-delegate (reassign) an existing delegation to a different person.
     * This soft-deletes the old delegation and all its descendants, then creates a new delegation.
     * No login required - uses HMAC token authentication.
     * @param questionnaireId
     * @param hmacToken
     * @param data
     * @returns RedelegateQuestionnaire
     * @throws ApiError
     */
    public static apiQuestionnairesRequestsRedelegateCreate(
      questionnaireId: string,
      hmacToken: string,
      data: RedelegateQuestionnaire,
    ): CancelablePromise<RedelegateQuestionnaire> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/questionnaires/requests/{questionnaire_id}/{hmac_token}/redelegate',
        path: {
          'questionnaire_id': questionnaireId,
          'hmac_token': hmacToken,
        },
        body: data,
      });
    }
    /**
     * @param reportDateId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiRetrieveInformationRequestStatusRead(
      reportDateId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<InformationRequestStatus>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/retrieve-information-request-status/{report_date_id}',
        path: {
          'report_date_id': reportDateId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @returns SCIMConfigurationRead
     * @throws ApiError
     */
    public static apiScimConfigurationFirmRead(
      firmId: string,
    ): CancelablePromise<SCIMConfigurationRead> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/scim/configuration/firm/{firm_id}',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * Create a new SCIM token for the given configuration. Maximum of two active tokens per configuration. If there are already two active tokens, the request will be rejected.
     * @param data
     * @returns SCIMTokenCreateResponse
     * @throws ApiError
     */
    public static apiScimConfigurationTokensCreate(
      data: {
        /**
         * ID of the SCIM configuration to create the token for
         */
        scim_configuration?: number;
      },
    ): CancelablePromise<SCIMTokenCreateResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/scim/configuration/tokens',
        body: data,
      });
    }
    /**
     * Revoke an active SCIM token. The token will be revoked immediately and cannot be used anymore. The revoked token will be returned in the response.
     * @param data
     * @returns SCIMTokenRead
     * @throws ApiError
     */
    public static apiScimConfigurationTokensRevokationCreate(
      data: SCIMTokenAction,
    ): CancelablePromise<SCIMTokenRead> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/scim/configuration/tokens/revokation',
        body: data,
      });
    }
    /**
     * Rotate an active SCIM token. The old token will be revoked and a new token will be created. The new token will be returned in the response.
     * @param data
     * @returns SCIMTokenCreateResponse
     * @throws ApiError
     */
    public static apiScimConfigurationTokensRotationCreate(
      data: SCIMTokenAction,
    ): CancelablePromise<SCIMTokenCreateResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/scim/configuration/tokens/rotation',
        body: data,
      });
    }
    /**
     * Update the SCIM configuration for the firm. Only one configuration can exist per firm.
     * @param configurationId
     * @param data
     * @returns SCIMConfigurationRead
     * @throws ApiError
     */
    public static apiScimConfigurationUpdate(
      configurationId: string,
      data: SCIMConfigurationUpdate,
    ): CancelablePromise<SCIMConfigurationRead> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/scim/configuration/{configuration_id}',
        path: {
          'configuration_id': configurationId,
        },
        body: data,
      });
    }
    /**
     * @param configurationId
     * @returns any
     * @throws ApiError
     */
    public static apiScimConfigurationPartialUpdate(
      configurationId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/scim/configuration/{configuration_id}',
        path: {
          'configuration_id': configurationId,
        },
      });
    }
    /**
     * @param configurationId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiScimConfigurationTokensList(
      configurationId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<SCIMTokenRead>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/scim/configuration/{configuration_id}/tokens',
        path: {
          'configuration_id': configurationId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * Concrete view for bulk saving spreadsheet note instances.
     * @param pageType
     * @param capTable
     * @param fundOwnership
     * @param financialStatement
     * @param fundMeasurementDate
     * @param allocation
     * @param valuationApproach
     * @param valuationApproachValuation
     * @param companyMeasurementDate
     * @param marketAdjustment
     * @param fundInvestmentOwnership
     * @param rangeSensitivity
     * @returns SpreadsheetNote
     * @throws ApiError
     */
    public static apiSpreadsheetNotesList(
      pageType?: string,
      capTable?: string,
      fundOwnership?: string,
      financialStatement?: string,
      fundMeasurementDate?: string,
      allocation?: string,
      valuationApproach?: string,
      valuationApproachValuation?: string,
      companyMeasurementDate?: string,
      marketAdjustment?: string,
      fundInvestmentOwnership?: string,
      rangeSensitivity?: string,
    ): CancelablePromise<Array<SpreadsheetNote>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/spreadsheet-notes/',
        query: {
          'page_type': pageType,
          'cap_table': capTable,
          'fund_ownership': fundOwnership,
          'financial_statement': financialStatement,
          'fund_measurement_date': fundMeasurementDate,
          'allocation': allocation,
          'valuation_approach': valuationApproach,
          'valuation_approach__valuation': valuationApproachValuation,
          'company_measurement_date': companyMeasurementDate,
          'market_adjustment': marketAdjustment,
          'fund_investment_ownership': fundInvestmentOwnership,
          'range_sensitivity': rangeSensitivity,
        },
      });
    }
    /**
     * Concrete view for bulk saving spreadsheet note instances.
     * @param data
     * @returns SpreadsheetNoteGet
     * @throws ApiError
     */
    public static apiSpreadsheetNotesCreate(
      data: Array<SpreadsheetNote>,
    ): CancelablePromise<Array<SpreadsheetNoteGet>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/spreadsheet-notes/',
        body: data,
      });
    }
    /**
     * Concrete view for retrieving SpreadsheetNote instances.
     * @param id
     * @returns SpreadsheetNoteGet
     * @throws ApiError
     */
    public static apiSpreadsheetNotesRead(
      id: string,
    ): CancelablePromise<SpreadsheetNoteGet> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/spreadsheet-notes/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param tenantPublicUuid
     * @returns any
     * @throws ApiError
     */
    public static apiSsoAcsCreate(
      tenantPublicUuid: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/sso/acs/{tenant_public_uuid}',
        path: {
          'tenant_public_uuid': tenantPublicUuid,
        },
      });
    }
    /**
     * Discover tenant based on user email. If tenant is not found, suggest standard password login as next step and login_url is null.
     * @param data
     * @returns TenantEmailDiscoveryResponse
     * @throws ApiError
     */
    public static apiSsoDiscoverCreate(
      data: TenantEmailDiscoveryRequest,
    ): CancelablePromise<TenantEmailDiscoveryResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/sso/discover',
        body: data,
      });
    }
    /**
     * Exchange an SSO exchange ticket for JWT tokens and user information.
     * @param data
     * @returns TokenExchangeResponse
     * @throws ApiError
     */
    public static apiSsoExchangeCreate(
      data: TokenExchangeRequest,
    ): CancelablePromise<TokenExchangeResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/sso/exchange',
        body: data,
      });
    }
    /**
     * Read metadata URL (if not null) ans save more tenant configuration for SSO integration.
     * @param data
     * @returns IntegrationMetadata
     * @throws ApiError
     */
    public static apiSsoIntegrationsMetadataCreate(
      data: IntegrationMetadata,
    ): CancelablePromise<IntegrationMetadata> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/sso/integrations/metadata',
        body: data,
      });
    }
    /**
     * Initiate SSO login for a specific tenant.
     * @param t Ephemeral ticket to initiate SSO login for a given tenant. Will be disposed after first use.
     * @returns any
     * @throws ApiError
     */
    public static apiSsoLoginList(
      t: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/sso/login',
        query: {
          't': t,
        },
        errors: {
          302: `Redirect to IdP SSO URL`,
        },
      });
    }
    /**
     * Discover tenant based on slug. If configured tenant is not found, suggest standard password login as next step and login_url is null.
     * @param data
     * @returns TenantSlugDiscoveryResponse
     * @throws ApiError
     */
    public static apiSsoSlugDiscoveryCreate(
      data: TenantSlugDiscovery,
    ): CancelablePromise<TenantSlugDiscoveryResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/sso/slug-discovery',
        body: data,
      });
    }
    /**
     * @param firmId
     * @returns TenantInformation
     * @throws ApiError
     */
    public static apiSsoTenantRead(
      firmId: string,
    ): CancelablePromise<TenantInformation> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/sso/tenant/{firm_id}',
        path: {
          'firm_id': firmId,
        },
      });
    }
    /**
     * @param companyId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanyPaymentMethodsList(
      companyId: string,
      page?: number,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/subscriptions/company/{company_id}/payment-methods',
        path: {
          'company_id': companyId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanyPaymentMethodsCreate(
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/subscriptions/company/{company_id}/payment-methods',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanyPaymentsRead(
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/subscriptions/company/{company_id}/payments',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanySubscriptionRead(
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/subscriptions/company/{company_id}/subscription',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanySubscriptionUpdate(
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/subscriptions/company/{company_id}/subscription',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsCompanySubscriptionPartialUpdate(
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/subscriptions/company/{company_id}/subscription',
        path: {
          'company_id': companyId,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsInitiatePaymentCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/subscriptions/initiate-payment',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiSubscriptionsSubscriptionSetupIntentCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/subscriptions/subscription/setup-intent',
      });
    }
    /**
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalList(
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<GlobalSummaryDefinition>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/summary-definitions/global',
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns GlobalSummaryDefinition
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalCreate(
      data: GlobalSummaryDefinition,
    ): CancelablePromise<GlobalSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/summary-definitions/global',
        body: data,
      });
    }
    /**
     * @param id
     * @returns GlobalSummaryDefinition
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalRead(
      id: string,
    ): CancelablePromise<GlobalSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/summary-definitions/global/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param data
     * @returns GlobalSummaryDefinition
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalUpdate(
      id: string,
      data: GlobalSummaryDefinition,
    ): CancelablePromise<GlobalSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/summary-definitions/global/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @param data
     * @returns GlobalSummaryDefinition
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalPartialUpdate(
      id: string,
      data: GlobalSummaryDefinition,
    ): CancelablePromise<GlobalSummaryDefinition> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/summary-definitions/global/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiSummaryDefinitionsGlobalDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/summary-definitions/global/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param q
     * @param limit
     * @param includeDocuments
     * @param includeSavedDestinations
     * @param contextFirmId
     * @param contextCompanyId
     * @param contextMeasurementDate
     * @returns SuperSearchResponse
     * @throws ApiError
     */
    public static apiSuperSearchList(
      q?: string,
      limit: number = 100,
      includeDocuments: boolean = false,
      includeSavedDestinations: boolean = false,
      contextFirmId?: number,
      contextCompanyId?: number,
      contextMeasurementDate?: string,
    ): CancelablePromise<SuperSearchResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/super-search',
        query: {
          'q': q,
          'limit': limit,
          'include_documents': includeDocuments,
          'include_saved_destinations': includeSavedDestinations,
          'context_firm_id': contextFirmId,
          'context_company_id': contextCompanyId,
          'context_measurement_date': contextMeasurementDate,
        },
      });
    }
    /**
     * @param data
     * @returns CreateOnboardingTasks
     * @throws ApiError
     */
    public static apiTasksOnboardingCreate(
      data: CreateOnboardingTasks,
    ): CancelablePromise<CreateOnboardingTasks> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/tasks/onboarding',
        body: data,
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiTasksShareCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/tasks/share',
      });
    }
    /**
     * @param cmdId
     * @returns Portal
     * @throws ApiError
     */
    public static apiTasksPortalLinksRead(
      cmdId: string,
    ): CancelablePromise<Portal> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/tasks/{cmd_id}/portal-links',
        path: {
          'cmd_id': cmdId,
        },
      });
    }
    /**
     * @param taskId
     * @returns TaskDetailedProgress
     * @throws ApiError
     */
    public static apiTasksProgressDetailRead(
      taskId: string,
    ): CancelablePromise<TaskDetailedProgress> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/tasks/{task_id}/progress-detail',
        path: {
          'task_id': taskId,
        },
      });
    }
    /**
     * @returns TOTPCreate
     * @throws ApiError
     */
    public static apiTotpCreateList(): CancelablePromise<TOTPCreate> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/totp/create/',
      });
    }
    /**
     * @returns TOTPDelete
     * @throws ApiError
     */
    public static apiTotpDeleteCreate(): CancelablePromise<TOTPDelete> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/totp/delete/',
      });
    }
    /**
     * @returns TOTPStatus
     * @throws ApiError
     */
    public static apiTotpGetList(): CancelablePromise<TOTPStatus> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/totp/get/',
      });
    }
    /**
     * @returns BackupCodes
     * @throws ApiError
     */
    public static apiTotpStaticCreateCreate(): CancelablePromise<BackupCodes> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/totp/static/create/',
      });
    }
    /**
     * @returns BackupCodes
     * @throws ApiError
     */
    public static apiTotpStaticGetList(): CancelablePromise<BackupCodes> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/totp/static/get/',
      });
    }
    /**
     * @param token
     * @returns BackupCodeVerify
     * @throws ApiError
     */
    public static apiTotpStaticVerifyCreate(
      token: string,
    ): CancelablePromise<BackupCodeVerify> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/totp/static/verify/{token}/',
        path: {
          'token': token,
        },
      });
    }
    /**
     * @param data
     * @returns TOTPUpdate
     * @throws ApiError
     */
    public static apiTotpUpdateCreate(
      data: TOTPUpdateRequest,
    ): CancelablePromise<TOTPUpdate> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/totp/update/',
        body: data,
      });
    }
    /**
     * @param token
     * @returns TOTPVerify
     * @throws ApiError
     */
    public static apiTotpVerifyCreate(
      token: string,
    ): CancelablePromise<TOTPVerify> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/totp/verify/{token}/',
        path: {
          'token': token,
        },
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns TaskDetailedProgress
     * @throws ApiError
     */
    public static apiUpdateInformationRequestStatusUpdate(
      informationRequestStatusId: string,
      data: UpdateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<Array<TaskDetailedProgress>> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/update-information-request-status/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * @param informationRequestStatusId
     * @param data
     * @returns UpdateDocumentAndQuestionnaireTasks
     * @throws ApiError
     */
    public static apiUpdateInformationRequestStatusPartialUpdate(
      informationRequestStatusId: string,
      data: UpdateDocumentAndQuestionnaireTasks,
    ): CancelablePromise<UpdateDocumentAndQuestionnaireTasks> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/update-information-request-status/{information_request_status_id}',
        path: {
          'information_request_status_id': informationRequestStatusId,
        },
        body: data,
      });
    }
    /**
     * @returns CustomUser
     * @throws ApiError
     */
    public static apiUserRead(): CancelablePromise<CustomUser> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/user',
      });
    }
    /**
     * @param id A unique integer value identifying this user.
     * @returns CustomUser
     * @throws ApiError
     */
    public static apiUserRead1(
      id: number,
    ): CancelablePromise<CustomUser> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/user/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiUserDeleteUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/user/{id}/delete',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns any
     * @throws ApiError
     */
    public static apiUserDeletePartialUpdate(
      id: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/user/{id}/delete',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiUserDeleteDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/user/{id}/delete',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @returns UserPermissionWithPath
     * @throws ApiError
     */
    public static apiUserLowerPermissionsList(
      id: string,
    ): CancelablePromise<Array<UserPermissionWithPath>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/user/{id}/lower-permissions',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @param id
     * @param firmId
     * @returns UserPermission
     * @throws ApiError
     */
    public static apiUserPermissionsRead(
      id: string,
      firmId: string,
    ): CancelablePromise<Array<UserPermission>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/user/{id}/permissions/{firm_id}',
        path: {
          'id': id,
          'firm_id': firmId,
        },
      });
    }
    /**
     * User listing view that supports both full and slim data via query parameter.
     * @param search A search term.
     * @returns any
     * @throws ApiError
     */
    public static apiUsersList(
      search?: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/users',
        query: {
          'search': search,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiUsersCreateBulkUsersCreate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/users/create-bulk-users',
      });
    }
    /**
     * @param id A unique integer value identifying this user.
     * @returns UserWithPermissions
     * @throws ApiError
     */
    public static apiUsersFirmUsersRead(
      id: number,
    ): CancelablePromise<Array<UserWithPermissions>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/users/firm_users/{id}/',
        path: {
          'id': id,
        },
      });
    }
    /**
     * List generation jobs created by the authenticated user.
     * GET /api/users/me/document-generation-jobs
     * GET /api/users/me/document-generation-jobs?active_only=true
     *
     * By default returns only active (PENDING / IN_PROGRESS) jobs.  For active
     * jobs the backend syncs status with the external document processing service
     * so that the ``post_save`` signal fires and notifications are sent.
     *
     * Query params:
     * active_only  — ``true`` (default) returns only PENDING/IN_PROGRESS jobs.
     * ``false`` returns all jobs for the user.
     * processing_type — optional filter (e.g. ``CAP_TABLE``, ``FINANCIAL_MAPPING``).
     * @param activeOnly Return only active (PENDING/IN_PROGRESS) jobs.
     * @param processingType Filter by processing type.
     * @returns RetrieveDocumentGenerationJob
     * @throws ApiError
     */
    public static apiUsersMeDocumentGenerationJobsList(
      activeOnly: boolean = true,
      processingType?: string,
    ): CancelablePromise<Array<RetrieveDocumentGenerationJob>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/users/me/document-generation-jobs',
        query: {
          'active_only': activeOnly,
          'processing_type': processingType,
        },
      });
    }
    /**
     * List every generation job the authenticated user may access, slim and paginated.
     * @param page 1-based page number.
     * @param pageSize Items per page (max 50).
     * @param processingType Filter by processing type (e.g. CAP_TABLE).
     * @param status Filter by job status (PENDING, IN_PROGRESS, COMPLETED, FAILED) - e.g. COMPLETED to fetch only re-runnable jobs.
     * @param firmId Narrow to one firm. Only firms the caller is a member of return rows; any other id yields an empty page.
     * @param companyId Narrow to one company within the caller's accessible firms; an out-of-scope id yields an empty page.
     * @returns any
     * @throws ApiError
     */
    public static apiUsersMeDocumentGenerationJobsSlimList(
      page?: number,
      pageSize?: number,
      processingType?: string,
      status?: string,
      firmId?: number,
      companyId?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<SlimUserGenerationJob>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/users/me/document-generation-jobs/slim',
        query: {
          'page': page,
          'page_size': pageSize,
          'processing_type': processingType,
          'status': status,
          'firm_id': firmId,
          'company_id': companyId,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiUsersPermissionsUpdate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/users/permissions',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiUsersPermissionsPartialUpdate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/users/permissions',
      });
    }
    /**
     * @param id
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiUsersPermissionsUpdate1(
      id: string,
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/users/permissions/{id}/{company_id}',
        path: {
          'id': id,
          'company_id': companyId,
        },
      });
    }
    /**
     * @param id
     * @param companyId
     * @returns any
     * @throws ApiError
     */
    public static apiUsersPermissionsPartialUpdate1(
      id: string,
      companyId: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/users/permissions/{id}/{company_id}',
        path: {
          'id': id,
          'company_id': companyId,
        },
      });
    }
    /**
     * @param id
     * @param companyId
     * @returns void
     * @throws ApiError
     */
    public static apiUsersPermissionsDelete(
      id: string,
      companyId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/users/permissions/{id}/{company_id}',
        path: {
          'id': id,
          'company_id': companyId,
        },
      });
    }
    /**
     * User listing view that only returns staff users.
     * @param search A search term.
     * @returns DashboardSmallUser
     * @throws ApiError
     */
    public static apiUsersStaffList(
      search?: string,
    ): CancelablePromise<Array<DashboardSmallUser>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/users/staff',
        query: {
          'search': search,
        },
      });
    }
    /**
     * Preview a Pre-FX currency conversion
     * Returns source_amount converted to host_currency at the FX rate for transaction_date. Identity short-circuit when source_currency == host_currency.
     * @param data
     * @returns PreFxPreviewResponse
     * @throws ApiError
     */
    public static apiV1CellAnnotationsPreFxPreviewCreate(
      data: PreFxPreviewRequest,
    ): CancelablePromise<PreFxPreviewResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/v1/cell-annotations/pre-fx/preview/',
        body: data,
        errors: {
          400: `Invalid input or no FX rate available for the given pair/date.`,
        },
      });
    }
    /**
     * @param alId
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationRead(
      alId: string,
    ): CancelablePromise<ValuationAllocationModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation-allocation/{al_id}',
        path: {
          'al_id': alId,
        },
      });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationUpdate(
      alId: string,
      data: ValuationAllocationModel,
    ): CancelablePromise<ValuationAllocationModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation-allocation/{al_id}',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationAllocationModel
     * @throws ApiError
     */
    public static apiValuationAllocationPartialUpdate(
      alId: string,
      data: ValuationAllocationModel,
    ): CancelablePromise<ValuationAllocationModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation-allocation/{al_id}',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param alId
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionRead(
      alId: string,
    ): CancelablePromise<NewValuationAllocationVersion> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation-allocation/{al_id}/new-version',
        path: {
          'al_id': alId,
        },
      });
    }
    /**
     * @param alId
     * @param data
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionUpdate(
      alId: string,
      data: NewValuationAllocationVersion,
    ): CancelablePromise<NewValuationAllocationVersion> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation-allocation/{al_id}/new-version',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param alId
     * @param data
     * @returns NewValuationAllocationVersion
     * @throws ApiError
     */
    public static apiValuationAllocationNewVersionPartialUpdate(
      alId: string,
      data: NewValuationAllocationVersion,
    ): CancelablePromise<NewValuationAllocationVersion> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation-allocation/{al_id}/new-version',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param measurementDateId
     * @param allocationVersion
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiValuationApproachesRead(
      measurementDateId: string,
      allocationVersion: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ValuationApproachModel>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/approaches/{measurement_date_id}/{allocation_version}/',
        path: {
          'measurement_date_id': measurementDateId,
          'allocation_version': allocationVersion,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns BulkValuationUpdateResponse
     * @throws ApiError
     */
    public static apiValuationBulkUpdateCreate(
      data: Array<BulkValuationUpdate>,
    ): CancelablePromise<Array<BulkValuationUpdateResponse>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/valuation/bulk-update',
        body: data,
      });
    }
    /**
     * @param firmId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiValuationCompGroupFirmRead(
      firmId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<CompGroupListCreate>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/comp-group/firm/{firm_id}',
        path: {
          'firm_id': firmId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param firmId
     * @param data
     * @returns CompGroupListCreate
     * @throws ApiError
     */
    public static apiValuationCompGroupFirmCreate(
      firmId: string,
      data: CompGroupListCreate,
    ): CancelablePromise<CompGroupListCreate> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/valuation/comp-group/firm/{firm_id}',
        path: {
          'firm_id': firmId,
        },
        body: data,
      });
    }
    /**
     * @param firmId
     * @param date
     * @returns FirmCompanyMeasurementDate
     * @throws ApiError
     */
    public static apiValuationFirmRead(
      firmId: string,
      date: string,
    ): CancelablePromise<Array<FirmCompanyMeasurementDate>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/firm/{firm_id}/{date}/',
        path: {
          'firm_id': firmId,
          'date': date,
        },
      });
    }
    /**
     * @param mdPk
     * @param currencies A currency pair in the $<TARGET><SOURCE>: format (e.g., $USDGBP:)
     * @param currencyDate The date for the exchange rate in MM/DD/YYYY or YYYY-MM-DD format
     * @returns any Exchange rate data
     * @throws ApiError
     */
    public static apiValuationGetExchangeRateRead(
      mdPk: string,
      currencies?: string,
      currencyDate?: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/get-exchange-rate/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
        query: {
          'currencies': currencies,
          'currency_date': currencyDate,
        },
        errors: {
          400: `Bad Request`,
          404: `Not Found`,
          500: `Internal Server Error`,
        },
      });
    }
    /**
     * @param transactionId
     * @returns TransactionId
     * @throws ApiError
     */
    public static apiValuationGetTransactionInformationRead(
      transactionId: string,
    ): CancelablePromise<TransactionId> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/get-transaction-information/{transaction_id}/',
        path: {
          'transaction_id': transactionId,
        },
      });
    }
    /**
     * @param mdPk
     * @returns GPC
     * @throws ApiError
     */
    public static apiValuationGpcRead(
      mdPk: string,
    ): CancelablePromise<GPC> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/gpc/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns BulkValuationUpdateResponse
     * @throws ApiError
     */
    public static apiValuationIndividualUpdateUpdate(
      valuationId: string,
      data: BulkValuationUpdate,
    ): CancelablePromise<BulkValuationUpdateResponse> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation/individual-update/{valuation_id}',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns BulkValuationUpdateResponse
     * @throws ApiError
     */
    public static apiValuationIndividualUpdatePartialUpdate(
      valuationId: string,
      data: BulkValuationUpdate,
    ): CancelablePromise<BulkValuationUpdateResponse> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation/individual-update/{valuation_id}',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param valuationId
     * @param updatedAt
     * @returns BulkValuationUpdateResponse
     * @throws ApiError
     */
    public static apiValuationIndividualUpdatePollRead(
      valuationId: string,
      updatedAt: string,
    ): CancelablePromise<BulkValuationUpdateResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/individual_update_poll/{valuation_id}/{updated_at}/',
        path: {
          'valuation_id': valuationId,
          'updated_at': updatedAt,
        },
      });
    }
    /**
     * @param mdPk
     * @returns GPC
     * @throws ApiError
     */
    public static apiValuationPcListRead(
      mdPk: string,
    ): CancelablePromise<GPC> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/pc-list/{md_pk}',
        path: {
          'md_pk': mdPk,
        },
      });
    }
    /**
     * @param id A unique integer value identifying this valuation approach gpc.
     * @param date
     * @param refreshDate
     * @returns boolean Boolean response
     * @throws ApiError
     */
    public static apiValuationPollRefreshCompsRead(
      id: number,
      date: string,
      refreshDate: string,
    ): CancelablePromise<boolean> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/poll-refresh-comps/{id}/{date}/{refresh_date}/',
        path: {
          'id': id,
          'date': date,
          'refresh_date': refreshDate,
        },
      });
    }
    /**
     * Recalculate Public Comps Dependencies based on both temp and persisted data, but from the perspective of the service it doesn't matter
     * @param data
     * @returns RecalculatePublicCompsDependenciesResponse
     * @throws ApiError
     */
    public static apiValuationPublicCompsRecalculateDependenciesCreate(
      data: RecalculatePublicCompsDependenciesRequest,
    ): CancelablePromise<Array<RecalculatePublicCompsDependenciesResponse>> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/valuation/public-comps/recalculate-dependencies',
        body: data,
      });
    }
    /**
     * Create a new public company refresh.
     * @param data
     * @returns boolean Updated
     * @throws ApiError
     */
    public static apiValuationRefreshCompsCreate(
      data: RefreshComps,
    ): CancelablePromise<boolean> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/valuation/refresh-comps/',
        body: data,
        errors: {
          400: `Bad Request`,
        },
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiValuationTickerSearchRead(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/ticker-search',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiValuationTransferOwnershipUpdate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation/transfer-ownership',
      });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static apiValuationTransferOwnershipPartialUpdate(): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation/transfer-ownership',
      });
    }
    /**
     * @param alId
     * @returns ValuationModel
     * @throws ApiError
     */
    public static apiValuationRead(
      alId: string,
    ): CancelablePromise<ValuationModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuation/{al_id}',
        path: {
          'al_id': alId,
        },
      });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationModel
     * @throws ApiError
     */
    public static apiValuationUpdate(
      alId: string,
      data: ValuationModel,
    ): CancelablePromise<ValuationModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation/{al_id}',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param alId
     * @param data
     * @returns ValuationModel
     * @throws ApiError
     */
    public static apiValuationPartialUpdate(
      alId: string,
      data: ValuationModel,
    ): CancelablePromise<ValuationModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation/{al_id}',
        path: {
          'al_id': alId,
        },
        body: data,
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns SetReadyForAudit
     * @throws ApiError
     */
    public static apiValuationReadyForAuditUpdate(
      valuationId: string,
      data: SetReadyForAudit,
    ): CancelablePromise<SetReadyForAudit> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuation/{valuation_id}/ready-for-audit',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param valuationId
     * @param data
     * @returns SetReadyForAudit
     * @throws ApiError
     */
    public static apiValuationReadyForAuditPartialUpdate(
      valuationId: string,
      data: SetReadyForAudit,
    ): CancelablePromise<SetReadyForAudit> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuation/{valuation_id}/ready-for-audit',
        path: {
          'valuation_id': valuationId,
        },
        body: data,
      });
    }
    /**
     * @param data
     * @returns EffectiveTaxRateWriteModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRateCreateCreate(
      data: EffectiveTaxRateWriteModel,
    ): CancelablePromise<EffectiveTaxRateWriteModel> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/valuations/effective-tax-rate/create',
        body: data,
      });
    }
    /**
     * @param companyMeasurementDate
     * @returns EffectiveTaxRateModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRateRead(
      companyMeasurementDate: string,
    ): CancelablePromise<EffectiveTaxRateModel> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
        path: {
          'company_measurement_date': companyMeasurementDate,
        },
      });
    }
    /**
     * @param companyMeasurementDate
     * @param data
     * @returns EffectiveTaxRateModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRateUpdate(
      companyMeasurementDate: string,
      data: EffectiveTaxRateModel,
    ): CancelablePromise<EffectiveTaxRateModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
        path: {
          'company_measurement_date': companyMeasurementDate,
        },
        body: data,
      });
    }
    /**
     * @param companyMeasurementDate
     * @param data
     * @returns EffectiveTaxRateModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRatePartialUpdate(
      companyMeasurementDate: string,
      data: EffectiveTaxRateModel,
    ): CancelablePromise<EffectiveTaxRateModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuations/effective-tax-rate/{company_measurement_date}',
        path: {
          'company_measurement_date': companyMeasurementDate,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this effective tax rate.
     * @param data
     * @returns EffectiveTaxRateWriteModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRateUpdateUpdate(
      id: number,
      data: EffectiveTaxRateWriteModel,
    ): CancelablePromise<EffectiveTaxRateWriteModel> {
      return __request(OpenAPI, {
        method: 'PUT',
        url: '/api/valuations/effective-tax-rate/{id}/update',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param id A unique integer value identifying this effective tax rate.
     * @param data
     * @returns EffectiveTaxRateWriteModel
     * @throws ApiError
     */
    public static apiValuationsEffectiveTaxRateUpdatePartialUpdate(
      id: number,
      data: EffectiveTaxRateWriteModel,
    ): CancelablePromise<EffectiveTaxRateWriteModel> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/valuations/effective-tax-rate/{id}/update',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * @param alId
     * @param page A page number within the paginated result set.
     * @returns any
     * @throws ApiError
     */
    public static apiValuationsRead(
      alId: string,
      page?: number,
    ): CancelablePromise<{
      count: number;
      next?: string | null;
      previous?: string | null;
      results: Array<ValuationModel>;
    }> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/valuations/{al_id}',
        path: {
          'al_id': alId,
        },
        query: {
          'page': page,
        },
      });
    }
    /**
     * @param data
     * @returns Scenario
     * @throws ApiError
     */
    public static apiWaterfallCreate(
      data: ScenarioValuesCalculation,
    ): CancelablePromise<Scenario> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/waterfall',
        body: data,
      });
    }
    /**
     * CRUD for named waterfall-input snapshots (saved views).
     * List/create:  GET|POST /api/waterfall-views/?company=<id>
     * @param measurementDate CompanyMeasurementDate ID
     * @param company Filter by company ID
     * @returns WaterfallView
     * @throws ApiError
     */
    public static apiWaterfallViewsList(
      measurementDate: number,
      company?: number,
    ): CancelablePromise<Array<WaterfallView>> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/waterfall-views',
        query: {
          'company': company,
          'measurement_date': measurementDate,
        },
      });
    }
    /**
     * CRUD for named waterfall-input snapshots (saved views).
     * List/create:  GET|POST /api/waterfall-views/?company=<id>
     * @param data
     * @returns WaterfallView
     * @throws ApiError
     */
    public static apiWaterfallViewsCreate(
      data: WaterfallView,
    ): CancelablePromise<WaterfallView> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/waterfall-views',
        body: data,
      });
    }
    /**
     * CRUD for named waterfall-input snapshots (saved views).
     * List/create:  GET|POST /api/waterfall-views/?company=<id>
     * @param id
     * @returns WaterfallView
     * @throws ApiError
     */
    public static apiWaterfallViewsRead(
      id: string,
    ): CancelablePromise<WaterfallView> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/waterfall-views/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * CRUD for named waterfall-input snapshots (saved views).
     * List/create:  GET|POST /api/waterfall-views/?company=<id>
     * @param id
     * @param data
     * @returns WaterfallView
     * @throws ApiError
     */
    public static apiWaterfallViewsPartialUpdate(
      id: string,
      data: WaterfallView,
    ): CancelablePromise<WaterfallView> {
      return __request(OpenAPI, {
        method: 'PATCH',
        url: '/api/waterfall-views/{id}',
        path: {
          'id': id,
        },
        body: data,
      });
    }
    /**
     * CRUD for named waterfall-input snapshots (saved views).
     * List/create:  GET|POST /api/waterfall-views/?company=<id>
     * @param id
     * @returns void
     * @throws ApiError
     */
    public static apiWaterfallViewsDelete(
      id: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/waterfall-views/{id}',
        path: {
          'id': id,
        },
      });
    }
    /**
     * @returns ZapierAuthTestResponse
     * @throws ApiError
     */
    public static apiZapierAuthTestList(): CancelablePromise<ZapierAuthTestResponse> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/zapier/auth/test/',
      });
    }
    /**
     * @param eventType
     * @returns any
     * @throws ApiError
     */
    public static apiZapierSamplesRead(
      eventType: string,
    ): CancelablePromise<any> {
      return __request(OpenAPI, {
        method: 'GET',
        url: '/api/zapier/samples/{event_type}/',
        path: {
          'event_type': eventType,
        },
      });
    }
    /**
     * @param data
     * @returns ZapierSubscriptionResponse
     * @throws ApiError
     */
    public static apiZapierSubscriptionsCreate(
      data: ZapierSubscriptionCreate,
    ): CancelablePromise<ZapierSubscriptionResponse> {
      return __request(OpenAPI, {
        method: 'POST',
        url: '/api/zapier/subscriptions/',
        body: data,
      });
    }
    /**
     * @param subscriptionId
     * @returns void
     * @throws ApiError
     */
    public static apiZapierSubscriptionsDelete(
      subscriptionId: string,
    ): CancelablePromise<void> {
      return __request(OpenAPI, {
        method: 'DELETE',
        url: '/api/zapier/subscriptions/{subscription_id}/',
        path: {
          'subscription_id': subscriptionId,
        },
        errors: {
          404: `Not Found`,
        },
      });
    }
  }
